// AUTO-STRUCTURED locale file. Keys mirror en.ts exactly; missing keys fall back
// to English (see src/i18n/index.ts). Placeholders use {name} interpolation.
export default {
 modelAuthorization: {
  "title": "Connect ChatGPT",
  "description": "Use your ChatGPT account for personal Cloud tasks.",
  "name": "Connection name",
  "enterCode": "Enter this code on the ChatGPT authorization page:",
  "openProvider": "Open ChatGPT authorization",
  "enableDevice": "Device code login must be enabled in your ChatGPT security settings. Complete sign-in there; this page checks automatically.",
  "chooseModels": "Connected. Close this dialog and browse the live model catalog to choose the models you want to use.",
  "cancel": "Cancel authorization",
  "retry": "Retry checking",
  "reauthorize": "Reauthorize",
  "done": "Done",
  "connect": "Connect ChatGPT",
  "failed": "Authorization failed. Retry.",
  "state": {
    "pending": "Waiting for authorization",
    "ready": "Connected",
    "expired": "Authorization code expired. Start again.",
    "requires_reauth": "Authorization required"
  }
},
  cloudRemoteInspector: {
    noModels: "No model is available on this device. Configure a provider on the device or add an available personal Cloud model.",
    modelSettings: "Model settings",
    fullPreview: "This preview includes committed and uncommitted changes against the target branch. Only the files you select will be published.",
    "createDraft": "Create draft pull request",
    "deliveryUpgrade": "Upgrade jcode on this device to publish reviewed changes.",
    "close": "Close",
    "delivering": "Publishing…",
    "publishDraft": "Push branch and create draft",
    "delivered": "Draft pull request created.",
    "openPR": "Open pull request",
    "deliveryExplanation": "Select the files you reviewed. This will push a separate branch using the device’s Git and GitHub CLI credentials. Your current branch, files and staging area are preserved.",
    "defaultBase": "Base: repository default branch",
    "prTitle": "Pull request title",
    "prBody": "Description (optional)",
    "selectFiles": "Select files to publish",
    "viewPatch": "Review patch",

    "title": "Task information",
    "changes": "Changes",
    "details": "Details",
    "upgradeRequired": "Upgrade jcode on this device to inspect workspace changes.",
    "setup": "Device setup",
    "files": "{count} files",
    "refresh": "Refresh",
    "offline": "The device is offline. Reconnect it to refresh these changes.",
    "workspaceChanges": "Current workspace changes relative to HEAD, including changes made before this task.",
    "clean": "No uncommitted workspace changes.",
    "truncated": "This preview is incomplete because it exceeds the display limit. Inspect the full changes on the device.",
    "updated": "Updated {time}",
    "device": "Device",
    "workspace": "Workspace",
    "branch": "Branch",
    "model": "Model",
    "connection": "Connection",
    "online": "Online",
    "offlineLabel": "Offline",
    "version": "jcode version",
    "openDevice": "Open device",
    "binary": "Binary file. Inspect its contents on the device."
},
  cloudRefresh: {
    "noGitProviders": "No Git login provider is configured. Ask an administrator to configure a provider connection.",
    "sessionNotFound": "Session not found",
    "addAttachments": "Add files",
    "uploading": "Uploading…",
    "attachmentReady": "Attached",
    "attachmentExpired": "Expired — upload again",
    "uploadFailed": "Upload failed. Retry or remove the file; ask an administrator if storage is unavailable.",
    "attachmentLimits": "Up to 10 files, 25 MiB each, 100 MiB total. Empty files are not supported.",
    "removeAttachment": "Remove {name}",

    "navigationFailed": "Could not load recent work.",
    "accountRequired": "Sign in with a personal account to manage these settings.",
    "noMatchingDevices": "No matching devices",
    "personalModelsEmpty": "Add a provider in model settings, or ask an administrator to authorize a model.",

    "personalModelsDescription": "Your personal models are available across repositories you can access.",
    "updateCredentials": "Update credentials",
    "enable": "Enable",
    "disable": "Disable",
    "deleteModel": "Delete {name}",
    "deleteModelConfirm": "Delete model {name}?",
    "availableModels": "Available task models",

    "defaultModel": "Default model",
    "automaticModel": "Choose an available model automatically",
    "unavailableModel": "Model unavailable — choose another",
    "defaultPermission": "Default execution permission",
    "askApproval": "Ask for approval",
    "fullAccess": "Full access",
    "planMode": "Plan only",
    "defaultEffort": "Default reasoning effort",
    "effort_auto": "Automatic",
    "effort_low": "Low",
    "effort_medium": "Medium",
    "effort_high": "High",
    "light": "Light",
    "dark": "Dark",
    "sendKey": "Send messages with",

    "recentRepositories": "Recent repositories",
    "remoteDevices": "Remote devices",
    "recentConversations": "Recent conversations",
    "allRepositories": "All repositories",
    "personalWorkspace": "Personal workspace",
    "homeTitle": "What would you like to work on?",
    "homeDescription": "Start with an idea. Let jcode help you move it forward.",
    "searchTasks": "Search tasks",
    "all": "All",
    "active": "In progress",
    "attention": "Needs attention",
    "completed": "Completed",
    "noMatch": "No matching tasks",
    "noMatchDescription": "Try another search or clear the filters.",
    "clearFilters": "Clear filters",
    "connectDevice": "Connect device",
    "searchDevices": "Search devices",
    "devicesTitle": "Your devices, ready to continue",
    "devicesDescription": "Open a workplace on a device signed in to jcode.",
    "noDevices": "No devices connected",
    "noDevicesDescription": "Connect jcode on a device to start remote work.",
    "backDevices": "Back to devices",
    "startRemote": "Start a remote task",
    "recentSessions": "Recent sessions",
    "deviceNotFound": "Device not found",
    "deviceUnavailable": "The device is unavailable or you do not have access.",
    "encryptedSession": "Encrypted session",
    "pairToRead": "Connect this browser to read the conversation."
},
  cloudDeviceGuide: {
    installHint: 'Install the latest jcode on this device to use Remote workspace features.',
    download: 'Download or update jcode',
    "secure": "End-to-end encrypted connection",
    "section": "Remote connection",
    "title": "Connect a jcode device",
    "description": "Log in, approve this device, then pair this browser to open its encrypted workspace and conversations.",
    "steps": "Remote onboarding steps",
    "login": "Log in to jcode",
    "approve": "Approve device",
    "pair": "Encrypted pairing",
    "newDevice": "New remote device",
    "minute": "About one minute",
    "runCommand": "Run the login command",
    "getCode": "Get a one-time device code",
    "confirmIdentity": "Confirm device identity",
    "approveAccount": "Approve account access",
    "completePair": "Complete pairing",
    "approveLocal": "Approve in local jcode",
    "onDevice": "On the device you want to connect",
    "runLogin": "Run jcode login",
    "commandDescription": "The command creates a one-time authorization code and normally opens this browser automatically. If it does not, enter the code below.",
    "terminal": "Terminal",
    "copyCommand": "Copy login command",
    "copyError": "Could not copy. Select and copy the command above.",
    "enterCode": "Enter the code shown by the CLI",
    "continue": "Continue authorization",
    "ciphertext": "Cloud only routes ciphertext",
    "ciphertextDescription": "The device code links this login to your account. Pairing keys stay in jcode and this browser; the server never reads conversation content.",
    "connected": "Already connected",
    "connectedDescription": "Open a device workspace, or continue above to add another device.",
    "expires": "The authorization code expires visibly in jcode."
},
  common: {
    ok: 'OK',
    add: 'Add',
    back: 'Back',
    cancel: 'Cancel',
    close: 'Close',
    save: 'Save',
    saving: 'Saving…',
    saved: 'Saved',
    delete: 'Delete',
    remove: 'Remove',
    edit: 'Edit',
    rename: 'Rename',
    retry: 'Retry',
    loading: 'Loading…',
    enable: 'Enable',
    disable: 'Disable',
    search: 'Search',
    done: 'Done',
    other: 'Other',
    details: 'Details',
    connected: 'Connected',
    disconnected: 'Disconnected',
    configured: 'Configured',
    notConfigured: 'Not configured',
    recommended: 'Recommended',
    copy: 'Copy',
    copied: 'Copied',
    dismiss: 'Dismiss',
    create: 'Create',
    creating: 'Creating…',
    confirm: 'Confirm',
    continue: 'Continue',
  },

  language: {
    label: 'Language',
  },

  format: {
    justNow: 'just now',
    minutesAgo: '{n}m ago',
    hoursAgo: '{n}h ago',
    daysAgo: '{n}d ago',
    durationSeconds: '{n}s',
    durationMinutes: '{m}m',
    durationMinutesSeconds: '{m}m {s}s',
    durationHoursMinutes: '{h}h {m}m',
  },

  run: {
    permissionArgumentsUnavailable: 'Arguments were not recorded for this older approval request.',
    thinking: 'Thinking',
    thinkingAria: 'Thinking…',
    projectMember: 'Repository member',
    toolStatusDone: 'Done',
    tool: {
      read: 'Read project context',
      edit: 'Edit files',
      execute: 'Run command',
      search: 'Search workspace',
    },
    toolStatus: {
      running: 'running',
      failed: 'failed',
      queued: 'queued',
      canceled: 'canceled',
    },
    statusName: {
      queued: 'Queued',
      running: 'Running',
      succeeded: 'Succeeded',
      failed: 'Failed',
      canceled: 'Canceled',
      scheduling: 'Scheduling',
      awaiting_input: 'Awaiting input',
      blocked: 'Blocked',
    },
    unknownStatus: 'Unknown',
    finalStatus: 'Final status: {status}',
    status: 'Status: {status}',
    artifactReady: 'Artifact ready: {artifact}',
    pushedAt: 'Pushed {branch} at {sha}',
    pushed: 'Pushed {branch}',
    result: {
      noChanges: 'No code changes',
      generic: 'Result',
    },
    session: {
      resumed: 'Session resumed',
      established: 'Session established',
      finished: 'Session finished',
      finishedIdle: 'Session finished (idle timeout)',
    },
    permissionTimedOut: 'Permission timed out',
    permissionResolved: 'Permission resolved',
    unknownEvent: 'Unknown event: {type}',
    toolStarted: '{tool} started',
    toolFailed: '{tool} failed',
    toolCompleted: '{tool} completed',
    permission: {
      label: 'permission',
      required: 'permission required',
      noAction: 'No action (cancelled)',
      timedOut: 'timed out',
      resolved: 'resolved',
      answered: 'Answered — waiting for the agent…',
      readonly: 'Read-only — a Repository member can answer.',
    },
  },

  device: {
    compose: {
      project: 'Working directory',
      model: 'Model',
      effort: 'Effort',
      goal: 'Goal',
      goalPlaceholder: 'What should this session achieve?',
      attachments: 'Attachments',
      attachAdd: 'Attach file',
      removeAttachment: 'Remove {name}',
      deviceDefault: 'Device default',
      attachmentTooBig: '{name} is over 2 MB — pick a smaller file.',
      attachmentTooMany: 'At most {max} attachments per message.',
      attachmentImage: '{name} is an image — images are not supported yet.',
    },
    // M14: jcode product composer (jcode-ui/product) strings, mapped onto
    // ProductComposerStrings by device-ui's buildProductComposerStrings.
    composer: {
      placeholder: 'Ask jcode or type / for commands',
      goalPlaceholder: 'Describe the goal — the agent pursues it until verifiably complete',
      queuePlaceholder: 'Agent is working — type to queue a follow-up…',
      attachedImages: '(see attached images)',
      send: 'Send',
      queue: 'Queue',
      stop: 'Stop',
      stopAgent: 'Stop agent (Esc)',
      stopAndNext: 'Stop current turn and send the next queued message',
      removeQueued: 'Remove from queue',
      add: 'Add',
      attachFiles: 'Attach files',
      command: 'Command',
      goal: 'Goal',
      workflowBadge: 'workflow',
      goalSlashDesc: 'Arm Goal mode — your next message becomes the objective',
      goalHintNext: 'Next message becomes the session goal',
      goalHintNextReplaces: 'Next message replaces the current goal',
      goalHintRemove: 'Remove goal',
      goalHintReplace: 'Setting a new goal replaces the current one',
      modelNoImages: 'Current model does not support images',
      modeApproval: 'Ask for approval',
      modeApprovalSub: 'Pause before each write or command.',
      modePlan: 'Plan',
      modePlanSub: 'Propose a plan first; nothing runs until you approve it.',
      modeAuto: 'Auto',
      modeAutoSub: 'AI reviewer allows safe tools; uncertain ones ask.',
      modeFullAccess: 'Full access',
      modeFullAccessSub: 'Act freely — no approval prompts.',
      modeCeilingHint: 'Cloud sessions are capped at Auto mode.',
      modelFilter: 'Filter models…',
      modelCurrent: 'Current',
      modelFavorites: '★ Favorites',
      modelReasoning: 'Reasoning',
      modelTools: 'Tool use',
      modelImages: 'Image input',
      modelNoImageInput: 'Current model does not support images',
      modelNone: 'No models available',
      modelNoMatch: 'No models match your filter.',
      modelManage: 'Manage models…',
      modelManageTitle: 'Manage Models',
      modelToggleVisibility: 'Toggle which models appear in the model selector',
      modelVisibleCount: '{visible} of {total} models visible in the selector',
      effort: 'Effort',
      effortTitle: 'Reasoning effort for this model',
      effortDefault: 'Default',
      contextTitle: 'Context capacity',
      contextSystemPrompt: 'System prompt',
      contextSystemTools: 'System tools',
      contextMcpTools: 'MCP tools',
      contextSkills: 'Skills',
      contextMessages: 'Messages',
      contextInput: 'Input',
      contextOutput: 'Output',
      contextCached: 'Cached',
      contextReasoning: 'Reasoning',
      contextCacheHitRate: 'Cache hit rate',
      workspaceNone: 'Choose folder',
      workspaceUnavailable: 'Current folder unavailable. Retry, select a folder, or upgrade jcode on this device to use Chat.',
      workspaceNewConversation: 'Return to the device page to choose a workspace for a new conversation.',
      workspaceNonePlural: 'No workspaces',
      workspaceSearch: 'Search workspaces',
      workspaceLoading: 'Loading…',
      workspaceNoFolders: 'No folders',
      workspaceOpen: 'Open',
      workspaceOpenFolder: 'Open folder',
      workspaceOpenError: 'Failed to open workspace',
      workspacePathPlaceholder: '/path/on/device',
      remoteConnect: 'Remote connect',
      branchesTitle: 'Branches',
      branchesNone: 'No branches',
      branchSearch: 'Search branches',
      branchCreate: 'Create & checkout new branch',
      branchCreateBtn: 'Create',
      branchNewName: 'new-branch-name',
      branchCurrent: 'Branch: {name}',
      branchConfirmTitle: 'Uncommitted work',
      branchConfirmIntro: 'Switching to "{branch}" would overwrite local files at:',
      branchConfirmMore: '+{count} more',
      branchConfirmStash: 'Stash & switch',
      branchConfirmDiscard: 'Discard & switch',
      branchConfirmCancel: 'Cancel',
      branchConfirmHint:
        'Stash saves your work (recover with git stash pop). Discard permanently deletes these files, including untracked ones.',
      branchSwitchError: 'Failed to switch branch',
      goalStatusActive: 'Active',
      goalStatusCompleted: 'Completed',
      goalStatusBlocked: 'Blocked',
      goalStarted: 'Started',
      goalElapsed: 'Elapsed',
      goalEdit: 'Edit',
      goalEditTitle: 'Edit goal',
      goalClear: 'Clear goal',
      goalSaveFailed: 'Could not save the goal',
      goalTokens: '{used} tokens',
      goalTokensK: '{k}k tokens',
      durationSeconds: '{n}s',
      durationMinutes: '{m}m {s}s',
      durationHours: '{h}h {m}m',
      commonTokens: '{used} tokens',
      commonLoading: 'Loading…',
      commonClose: 'Close',
      commonCancel: 'Cancel',
      commonSave: 'Save',
      commonDone: 'Done',
      commonEnable: 'Enable',
      commonDisable: 'Disable',
      commonRecommended: 'Recommended',
    },
    list: {
      title: 'Devices',
      subtitle: 'jcode devices connected to your account. Send work to any online machine.',
      emptyTitle: 'No devices yet',
      emptyBody: 'Run `jcode login` on a machine to connect it to jcode Cloud.',
      online: 'Online',
      offline: 'Offline',
      lastSeen: 'Last seen {time}',
      neverSeen: 'Never seen',
      loadErrorTitle: 'Could not load devices',
      servicePrincipal: 'Devices are tied to a user account — sign in with a user session, not the console service token.',
      platformDesktop: 'Desktop',
      platformCli: 'CLI',
      e2ee: 'End-to-end encrypted',
      e2eeWithKeyGen: 'End-to-end encrypted · key generation {gen}',
    },
    welcome: {
      back: 'Devices',
      newSession: 'New session',
      composerPlaceholder: 'Ask jcode anything…',
      send: 'Send',
      mode: 'Mode',
      sessions: 'Sessions',
      sessionCount_one: '{count} session',
      sessionCount_other: '{count} sessions',
      noSessions: 'No sessions yet — send a message to start one.',
      creating: 'Creating session…',
      createSlow: 'The device is taking a while — the session will appear shortly.',
      untitled: 'Untitled session',
      offlineBanner: 'This device is offline. Messages cannot be sent until it reconnects.',
      delete: 'Delete device',
      deleteConfirm: 'Delete {name}? The device is signed out and stops syncing. Session history is kept on the server.',
      deleted: 'Device {name} deleted',
      sessionDelete: 'Delete session',
      sessionDeleteRunning: 'Stop the session before deleting it',
      sessionDeleteConfirm: 'Delete “{name}” from the desktop and cloud?',
      sessionDeleted: 'Session “{name}” deleted',
      status: {
        idle: 'Idle',
        running: 'Running',
      },
    },
    session: {
      back: 'Back to device',
      thinking: 'Thinking',
      thinkingAria: 'Thinking…',
      you: 'You',
      send: 'Send',
      stop: 'Stop',
      composerPlaceholder: 'Message jcode…',
      offlineBanner: 'Device offline — sending is disabled until it reconnects.',
      streamError: 'Live stream interrupted — reconnecting…',
      reconnect: 'Reconnect',
      approve: 'Approve',
      approveAll: 'Always allow',
      deny: 'Deny',
      toolDenied: 'denied',
      askUser: 'jcode asked a question (answer it on the device):',
      agentStarted: 'Agent started',
      agentDone: 'Agent finished',
      agentStopped: 'Stopped by user',
      agentFailed: 'Agent failed: {message}',
      taskRunning: 'Session running',
      taskIdle: 'Session idle',
      modeChanged: 'Mode changed to {mode}',
      modelChanged: 'Model changed to {model}',
      sessionReset: 'Session reset',
      todoUpdated: 'Todos updated',
      goalUpdated: 'Goal updated: {objective}',
      goalCleared: 'Goal cleared',
      subagentStarted: 'Subagent {name} started',
      subagentDone: 'Subagent {name} finished',
      subagentFailed: 'Subagent {name} failed',
      sendFailed: 'Could not send: {message}',
      deviceOffline: 'Device is offline',
      emptyHistory: 'No events in this session yet.',
      source: {
        console: 'Console',
        mobile: 'Mobile',
        desktop: 'Desktop',
        wechat: 'WeChat',
        local: 'Local',
      },
    },
    guide: {
      entry: 'Usage guide',
      title: 'Using your jcode devices',
      subtitle: 'How to connect a machine with `jcode login` and drive it from the browser or the mobile app.',
      back: 'Back to devices',
      shots: {
        devices: 'Device list in the cloud console',
        welcome: 'Device page: start a new session and browse existing ones',
        session: 'A session streaming live from the device',
        offline: 'An offline device still shows its history',
        login: 'Sign-in screen of the mobile app',
      },
      what: {
        title: 'What is a "device"?',
        p1: 'A device is a machine running jcode (CLI or desktop) that was signed in to jcode Cloud with `jcode login`. Once connected, you can view and control that machine remotely from the cloud console or the mobile app.',
        p2: 'The cloud only relays traffic: your machine dials out to the cloud, so no inbound ports or VPN are needed. Sessions keep running — and stay stored — on your machine.',
      },
      quickstart: {
        title: 'Quick start',
        p1: 'On the machine you want to control, run:',
        code1: 'jcode login',
        p2: 'The CLI prints a code and a confirmation link — approve the sign-in in your browser. The device then connects automatically and appears in your device list.',
        p3: 'By default jcode signs in to https://cloud.j-code.net. For a self-hosted cloud, pass its URL — it must use https (plain http is only allowed for localhost during development):',
        code2: 'jcode login --cloud https://your-cloud.example.com',
      },
      remote: {
        title: 'Using a device remotely',
        p1: 'Open the device list and pick a device. From there you can start a new session, follow running sessions live, stop a run, and answer approval prompts — the same controls as on the machine itself.',
        p2: 'When a device is offline you can still read its session history, but sending messages and approvals is disabled until it reconnects.',
      },
      pairing: {
        title: 'Pairing & end-to-end encryption',
        p1: 'Session content is end-to-end encrypted: the cloud only stores ciphertext and routing metadata, so it cannot read your sessions. A new client (a new browser or a phone) must pair with a device before it can decrypt anything.',
        p2: 'Start pairing from the browser or mobile app. Then open jcode Desktop on the device, go to Settings → Cloud, verify the client label, and approve or deny the request within 10 minutes. The CLI remains available for automation:',
        code1: 'jcode cloud pairings',
        code2: 'jcode cloud approve <pairing_id>',
        p3: 'Desktop Settings → Cloud is the recommended approval path. `pairings` lists pending requests for automation; `approve` authorizes one (reject with `jcode cloud deny <pairing_id>`).',
      },
      keys: {
        title: 'Keys & recovery',
        p1: 'The encryption key (CEK) is generated on your first device and never leaves your devices in plaintext. Back it up once as a 24-word recovery phrase and keep it somewhere safe:',
        code1: 'jcode cloud key show-phrase',
        p2: 'If every device is lost, restore the key on a freshly signed-in device from the phrase:',
        code2: 'jcode cloud key recover',
        p3: 'To rotate the key (paired clients will need to pair again):',
        code3: 'jcode cloud rotate-key',
      },
      commands: {
        title: 'Command reference',
        p1: 'The everyday commands, all run on the device:',
        rows: {
          login: 'Sign this machine in to jcode Cloud (device-code flow).',
          loginStatus: 'Show the current sign-in status and exit.',
          logout: 'Sign out, revoke the device token and remove local credentials.',
          cloudStatus: 'Show cloud URL, device id, key generation and reachability.',
          pairings: 'List pending pairing requests from clients.',
          approve: 'Approve a pairing request (hands the encrypted key to the client).',
          deny: 'Deny a pairing request.',
          showPhrase: 'Reveal the 24-word recovery phrase for the encryption key.',
          recover: 'Rebuild the encryption key from a recovery phrase.',
          rotateKey: 'Generate a new key (key_gen+1); paired clients must re-pair.',
        },
        e2eeNote: 'E2E encryption is on by default. To temporarily disable it (plaintext uplink, e.g. for debugging), set "cloud": { "e2ee": false } in `~/.jcode/config.json` and restart `jcode web`.',
      },
    },
    pairing: {
      start: 'Pair this client',
      requests: {
        title: 'Pairing requests',
        body: 'This approved client can securely approve another browser or phone.',
        approve: 'Approve',
        deny: 'Deny',
        approvalLost: 'This client is no longer approved. Pair it again first.',
      },
      idle: {
        title: 'End-to-end encryption not set up',
        body: 'Start pairing from this client. A review request will appear in jcode Desktop under Settings → Cloud; encrypted content stays locked until you approve it there.',
      },
      pending: {
        title: 'Waiting for approval on the device',
        body: 'Open jcode Desktop on the device, go to Settings → Cloud, verify this client, and approve or deny the request within 10 minutes.',
      },
      denied: {
        title: 'Pairing denied',
        body: 'The device denied this pairing request. Start a new one if that was a mistake.',
      },
      expired: {
        title: 'Pairing expired',
        body: 'The pairing request was not approved within 10 minutes. Start a new one.',
      },
      gate: {
        title: 'Pairing required',
        body: 'This device enforces end-to-end encryption. Session content and controls stay unavailable until pairing completes.',
      },
      error: {
        title: 'Pairing failed',
        body: 'Something went wrong while pairing. Try again.',
      },
    },
    securityEyebrow: 'Device sign-in',
    title: 'Authorize a device',
    lede: 'jcode Desktop is asking to sign in to this cloud. Enter the code shown in Desktop to continue.',
    safetyTitle: 'Only approve a request you started',
    enterTitle: 'Enter the code from Desktop',
    codeLabel: 'Device code',
    codeHint: 'The 8-character code shown in jcode Desktop, e.g. XXXX-XXXX.',
    codeCell: 'Character {n} of {total}',
    codeRequired: 'Enter the code shown in jcode Desktop.',
    continue: 'Continue',
    confirmTitle: 'Is this your device?',
    confirmBody: 'Approve only if this code matches the current sign-in request shown in jcode Desktop.',
    approve: 'Approve',
    deny: 'Deny',
    approvedTitle: 'Device approved',
    approvedBody: 'Return to jcode Desktop; sign-in will finish automatically.',
    deniedTitle: 'Device denied',
    deniedBody: 'The sign-in request was rejected. jcode Desktop will stop waiting.',
    another: 'Authorize another device',
    unavailableTitle: 'This sign-in request is no longer available',
    tryAnotherCode: 'Try another code',
    backToDevices: 'Back to devices',
    errorNotFound: 'No pending sign-in matches that code — it may have expired. Start sign-in again from jcode Desktop.',
    errorAlreadyDecided: 'That sign-in was already approved or denied.',
    errorGeneric: 'Could not authorize the device. Try again.',
  },

  workspace: {
    provider: {
      pathOrUrl: 'Path / remote URL',
      gitRepository: 'Git repository',
    },
    runKind: {
      review: 'Review',
      prEvent: 'PR event',
      schedule: 'Schedule',
      kanban: 'Kanban',
      webhook: 'Webhook',
      session: 'Session',
      task: 'Task',
    },
  },

  shell: {
    skipToContent: 'Skip to content',
    globalNav: 'Global navigation',
    primaryNav: 'Primary',
    workspaceEyebrow: 'Workspace',
    adminEyebrow: 'Administration',
    clusterTitle: 'Cluster',
    cloudTitle: 'jcode Cloud',
    clusterSubtitle: 'Cluster configuration',
    cloudSubtitle: 'Self-hosted coding workspace',
    projects: 'Projects',
    cluster: 'Cluster',
    devices: 'Devices',
    clusterSections: 'Cluster sections',
    adminBadge: 'admin',
    recentProjects: 'Recent repositories',
    recentEmpty: 'Repositories you open will appear here as shortcuts.',
    recentAria: 'Recent repositories',
    workspaceAria: 'jcode Cloud workspace',
    demoEnv: 'demo / local',
    orchestratorEnv: 'orchestrator',
    demoTag: 'DEMO',
    switchToLight: 'Switch to light mode',
    switchToDark: 'Switch to dark mode',
    services_one: '{count} service',
    services_other: '{count} services',
    crumbProjects: 'Projects',
    crumbNewProject: 'New Project',
    crumbCluster: 'Cluster',
    crumbModels: 'Models',
    crumbConnections: 'Connections',
    crumbOverview: 'Overview',
    crumbWorkspace: 'Workspace',
    crumbProject: 'Project',
    crumbDevice: 'Device',
    crumbSession: 'Session',
    crumbNotFound: 'Not found',
  },

  cluster: {
    accessDenied: {
      roleCode: 'ROLE / PROJECT ADMIN',
      title: 'Cluster stays outside this role.',
      body: 'Your role manages Projects only. Capacity, model credentials, guardrails, and provider configuration require a Cluster administrator.',
      noticeTitle: 'The Cluster navigation is intentionally hidden.',
      noticeBody: 'This direct route explains the boundary without issuing a system snapshot request.',
      backToProjects: 'Back to Projects',
    },
    overview: {
      loadingSnapshot: 'Loading cluster snapshot…',
      snapshotLoadError: 'Couldn\'t load the cluster snapshot',
      eyebrow: 'Orchestrator snapshot',
      title: 'Cluster',
      description: 'Capacity, guardrails, and runtime wiring for this orchestrator. Editable configuration stays in its owning section.',
      metaNamespace: 'namespace / {value}',
      metaLauncher: 'launcher / {value}',
      metaCommit: 'commit / {value}',
      snapshotLoaded: 'snapshot loaded',
      refresh: 'Refresh',
      capacitySummaryAria: 'Run capacity summary',
      metricRunning: 'Running',
      metricRunningNote: 'active now',
      metricScheduling: 'Scheduling',
      metricSchedulingNote: 'awaiting pod',
      metricQueued: 'Queued',
      metricQueuedNote: 'waiting for capacity',
      metricMax: 'Max',
      metricMaxNote: 'concurrent Runs',
      capacityTitle: 'Capacity',
      capacityAside: '{active} active / {max} max',
      concurrencyUncapped: 'Concurrency is not capped',
      concurrencyInUse: 'of configured concurrency is in use',
      unlimitedSlots: 'unlimited slots',
      slotsAvailable: '{count} slots available',
      legendRunning: '{count} running',
      legendScheduling: '{count} scheduling',
      gitPolicyTitle: 'Git provider policy',
      giteaEnabled: 'Gitea enabled',
      giteaDisabled: 'Gitea disabled',
      giteaUrlLabel: 'Gitea URL',
      draftPrLabel: 'Draft PR output',
      draftPrAvailable: 'Available to authorized identities',
      draftPrUnavailable: 'Unavailable — diff only',
      allowedHostsLabel: 'Allowed Git hosts',
      unrestricted: 'unrestricted',
      modelsConfigured_one: '{count} catalog model is configured.',
      modelsConfigured_other: '{count} catalog models are configured.',
      modelsManagedPrefix: 'Model credentials and Account access are managed in ',
      modelsLink: 'Models',
      modelsManagedSuffix: '; Accounts and Repositories never receive provider keys.',
      guardrailsTitle: 'Guardrails',
      runTimeoutLabel: 'Run timeout',
      jobTtlLabel: 'Job TTL',
      runnerTitle: 'Runner',
      imageLabel: 'Image',
      launcherLabel: 'Launcher',
      workspaceLabel: 'Workspace',
      persistent: 'Persistent',
      ephemeral: 'Ephemeral',
      prewarmLabel: 'Image prewarm',
      prewarmUnsupported: 'Requires the kubernetes launcher',
      prewarmNever: 'Never synced',
      prewarmReady: '{ready}/{desired} nodes cached',
      prewarmLastSyncLabel: 'Last synced',
      prewarmSync: 'Sync latest image',
      prewarmSyncError: 'Sync failed — see the orchestrator logs',
      buildTitle: 'Build',
      versionLabel: 'Version',
      commitLabel: 'Commit',
      usersLabel: 'Users',
      coldArchiveUnavailable: 'Cold archive is unavailable.',
    },
    models: {
      contextUnknown: 'context unknown',
      contextK: '{value}K context',
      context: '{value} context',
      eyebrow: 'Cluster catalog',
      title: 'Model providers',
      description: 'Connect providers once, keep credentials sealed, then grant model access directly to Accounts.',
      addProvider: 'Add provider',
      securityNote: 'Provider keys are write-only. The catalog reports only whether a credential is configured, never any part of the stored value.',
      filterLabel: 'Filter models or providers',
      filterPlaceholder: 'Filter models or providers…',
      resultCount: '/ {total} models',
      configuredProviders: 'Configured providers',
      providersSummary: '{providers} providers · {accountGrants} Account grants',
      loadingProviders: 'Loading model providers…',
      loadProvidersError: 'Couldn\'t load model providers',
      noMatches: 'No matching models or providers.',
      noProviders: 'No model providers configured.',
      noMatchesHint: 'Try a provider name, model id, or capability.',
      noProvidersHint: 'Add a provider to make models available to Accounts across Desktop and Repository runs.',
      authServiceIdentity: 'service identity',
      authKeySet: 'key set',
      authKeyless: 'keyless',
      authKeyMissing: 'key missing',
      verifiedIn: 'Provider verified in {ms} ms.',
      reachableIn: 'Provider reachable in {ms} ms; catalog unavailable.',
      verifyError: 'Could not verify the provider.',
      removeConfirm: 'Remove {name} and all of its configured models?',
      providerRemoved: 'Provider removed.',
      removeError: 'Could not remove the provider.',
      customLabel: 'custom',
      credKeylessIdentity: 'keyless workload identity',
      credConfigured: 'credential configured',
      credNoneRequired: 'no credential required',
      credRequired: 'credential required',
      lastTest: 'Last test: {error}',
      verified: 'Verified',
      test: 'Test',
      editProviderAria: 'Edit {name} provider',
      removeProviderAria: 'Remove {name} provider',
      customModel: 'custom model',
      configuredModel: 'configured model',
      configuredModels: 'configured models',
      catalogUnavailable: 'Catalog unavailable',
      browseCatalog: 'Browse catalog',
      customModelAction: 'Custom model',
      limitNote: 'This endpoint does not expose a model catalog. Models must be added explicitly; no fallback catalog is substituted.',
      capabilitiesAria: 'Model capabilities',
      capReasoning: 'Reasoning',
      capTools: 'Tools',
      capImage: 'Image',
      projectGrants_one: 'Project grant',
      projectGrants_other: 'Project grants',
      accountGrants_one: 'Account grant',
      accountGrants_other: 'Account grants',
      manageAccess: 'Manage access',
      capabilitiesLegend: 'Capabilities',
      capToolUse: 'Tool use',
      capImageInput: 'Image input',
      customValidationRequired: 'Display name and Model ID are required.',
      customValidationContext: 'Context window must be zero or a positive number.',
      customAdded: 'Custom model added.',
      addModelError: 'Could not add the model.',
      customDialogTitle: 'Custom model · {name}',
      addCustomModel: 'Add custom model',
      displayNameLabel: 'Display name',
      displayNamePlaceholder: 'e.g. Coding Plan',
      modelIdLabel: 'Model ID',
      modelIdHint: 'The bare upstream model id; the runtime provider prefix is added server-side.',
      contextWindowLabel: 'Context window',
      modelAdded: '{name} added.',
      addCatalogError: 'Could not add the catalog model.',
      syncMetadata: 'Sync metadata',
      metadataSynced: '{name} metadata synced.',
      syncMetadataError: 'Could not sync model metadata.',
      catalogDialogTitle: 'Catalog · {name}',
      loadingCatalog: 'Loading provider catalog…',
      catalogLoadError: 'Could not load catalog',
      catalogLoadFallback: 'The provider catalog could not be loaded.',
      grantUpdateError: 'Could not update the Project grant.',
      accountGrantUpdateError: 'Could not update Account access.',
      accessDialogTitle: 'Model access · {name}',
      accessIntro: 'Grant one Account access for both Cloud and Desktop. Provider credentials remain sealed at the Cluster boundary.',
      accessTabsAria: 'Model access scope',
      accessAccounts: 'Accounts',
      accessProjects: 'Projects',
      accountAccessIntro: 'A granted Account can use this model for Repository runs and every authenticated Desktop, including devices added later.',
      projectAccessIntro: 'Granted Projects can select this model for Cloud runs.',
      accountSearchLabel: 'Search Accounts',
      accountSearchPlaceholder: 'Search Accounts…',
      loadingAccounts: 'Loading Accounts…',
      noAccounts: 'No matching Accounts.',
      allDesktops: 'All current and future Desktops',
      allCloudAndDesktop: 'All Repository runs and Desktops',
      clusterAdminAccount: 'Cluster admin · all Desktops',
      loadingProjects: 'Loading Projects…',
      noProjects: 'No Projects exist yet.',
      servicesCount: '{count} Services',
      providerValidationRequired: 'Name, provider type, and Base URL are required.',
      providerValidationKey: 'API key is required for a new API-key provider.',
      providerSaved: 'Provider saved.',
      saveProviderError: 'Could not save the provider.',
      providerAdded: 'Provider added.',
      addProviderError: 'Could not add the provider.',
      editProviderTitle: 'Edit provider · {name}',
      addProviderTitle: 'Add model provider',
      saveProvider: 'Save provider',
      providerSourceLabel: 'Provider source',
      providerRegistryMode: 'Provider',
      providerCustomMode: 'Custom',
      providerSelectLabel: 'Provider',
      providerSelectPlaceholder: 'Select a provider',
      providerNameLabel: 'Provider name',
      providerNamePlaceholder: 'e.g. Zhipu AI',
      providerTypeLabel: 'Provider type',
      providerTypeHint: 'A lowercase runtime prefix such as openai, qwen, or zhipu.',
      baseUrlLabel: 'Base URL',
      authLabel: 'Authentication',
      authApiKey: 'API key',
      authServiceIdentityOption: 'Service identity',
      authNone: 'No credential',
      rotateApiKeyLabel: 'Rotate API key',
      apiKeyPlaceholderKeep: 'Leave blank to keep current key',
      apiKeyPlaceholderEnter: 'Enter provider key',
      apiKeyHint: 'Write-only. The saved value can never be read back.',
      catalogLabel: 'Model catalog',
      catalogAuto: 'Discover from /models',
      catalogDisabled: 'Unavailable — custom models only',
      advancedLabel: 'Advanced',
      headersHint: 'Custom headers sent with every request to this provider. Values are write-only.',
      headersConfiguredHint: 'Custom headers are configured. Add rows to replace them, or leave blank to keep.',
      headerKeyPlaceholder: 'Header name',
      headerValuePlaceholder: 'Value',
      addHeader: 'Add header',
      removeHeader: 'Remove header',
      headerValidation: 'Each header needs both a name and a value.',
    },
    connections: {
      loading: 'Loading cluster connections…',
      statusError: 'Couldn\'t load connection status',
      configError: 'Couldn\'t load jtype configuration',
      eyebrow: 'External systems',
      title: 'Connections',
      description: 'Cluster-wide endpoints and identity providers. Repository authorization remains inside each Repository connection.',
      configurationTabs: 'Connection configuration',
      integrationsTab: 'Integration configuration',
      loginTab: 'Login settings',
      statusEyebrow: 'Effective state',
      statusTitle: 'Connection status',
      statusDescription: 'Read-only runtime state reported by the cluster, kept separate from editable provider configuration.',
      configuredCount: '{count} configured',
      gitPolicyTitle: 'Git provider policy',
      gitPolicySubtitle: 'Environment-owned · read only',
      giteaEnabled: 'Gitea enabled',
      giteaDisabled: 'Gitea disabled',
      giteaUrlLabel: 'Gitea URL',
      clusterPatLabel: 'Cluster PAT',
      patConfigured: 'Configured · value hidden',
      allowedHostsLabel: 'Allowed hosts',
      unrestricted: 'unrestricted',
      oobTitle: 'Changes are made out of band.',
      oobBody: 'Provider URL, PAT, and host allowlist remain deployment configuration; this page reports effective state.',
      authTitle: 'Authentication',
      registeredUsers: '{count} registered users',
      oauthOn: 'OAuth on',
      tokenOnly: 'token only',
      giteaOauthLabel: 'Gitea OAuth',
      githubOauthLabel: 'GitHub OAuth',
      consoleTokenLabel: 'Console token',
      consoleTokenValue: 'Cluster-admin fallback',
      oauthSecurityNote: 'OAuth redirect URIs are changed through the provider UI because API patching rotates the client secret.',
      githubUnavailableTitle: 'GitHub sign-in is unavailable.',
      githubUnavailableBody: 'No GitHub OAuth provider is configured. The UI does not show a working GitHub button until the provider exists.',
      providerHealth: {
        unknown: 'Not tested',
        healthy: 'Healthy',
        partial: 'Basic connection healthy',
        error: 'Error',
        incomplete: 'Incomplete',
      },
      providerHealthError: 'Connection check failed: {message}',
      githubAppSetupIncomplete: 'GitHub App setup incomplete',
      instanceUrl: 'Instance URL',
      providerCapabilities: 'Provider capabilities',
      loginEnabled: 'Login enabled',
      loginCapability: 'Login',
      loginCapabilityHint: 'Allow this Provider for Cloud sign-in.',
      pluginEnabled: 'Plugin enabled',
      pluginCapability: 'Plugin',
      pluginCapabilityHint: 'Allow Repositories to connect and use it.',
      oauthClientId: 'OAuth client ID',
      oauthClientSecret: 'OAuth client secret',
      configuredReplace: 'Configured — enter to replace',
      enterSecret: 'Enter secret',
      githubAppId: 'GitHub App ID',
      githubAppPrivateKey: 'GitHub App private key',
      configuredPemReplace: 'Configured — paste a PEM to replace',
      pastePrivateKeyPem: 'Paste the complete private-key PEM',
      privateKeyHint: 'Write-only. Cloud encrypts the PEM and never returns it to the browser.',
      webhookSecret: 'Webhook secret',
      webhookSecretPlaceholder: 'Enter the same secret configured in GitHub',
      githubAppConfigurationIncomplete: 'GitHub App configuration is incomplete',
      githubAppConfigurationIncompleteHint: 'Add the App ID, private key, and matching webhook secret before Accounts can list Installations.',
      testConnection: 'Test connection',
      jtypeSaved: 'jtype connection saved.',
      jtypeSaveError: 'Could not save jtype.',
      jtypeOverrideRemoved: 'jtype DB override removed.',
      jtypeRemoveError: 'Could not remove the override.',
      sourceDb: 'DB override',
      sourceEnv: 'environment fallback',
      sourceNone: 'not configured',
      jtypeKanban: 'jtype Kanban',
      pollingEvery: 'polling every {interval}',
      jtypeEffective: 'effective',
      jtypeBroken: 'broken',
      jtypeOff: 'off',
      baseUrlLabel: 'Base URL',
      baseUrlHint: 'The jtype instance this cluster talks to. Kanban credentials are per-link, managed by each project owner.',
      boardTrafficNote: 'Board traffic passes through the server proxy. The jtype token never enters the browser.',
      jtypeUnavailableTitle: 'jtype configuration is unavailable.',
      removeOverride: 'Remove override',
      saveJtype: 'Save jtype',
      archiveTitle: 'Workspace archive',
      archiveSubtitle: 'Persistent workspace cold storage',
      archiveEnabled: 'enabled',
      archiveUnavailable: 'unavailable',
      endpointLabel: 'Endpoint',
      bucketLabel: 'Bucket',
      idleWindowLabel: 'Idle window',
      idleDays: '{count} days',
      archiveDisabledTitle: 'Long-term archive is not enabled.',
      archiveDisabledReason: 'Object storage is not configured.',
    },
    system: {
      forbiddenTitle: 'Cluster view is for cluster admins',
      forbiddenDescription: 'Your role manages projects only. Ask a cluster administrator for capacity, guardrail, and provider details.',
      title: 'Cluster',
      subtitle: 'Snapshot of this orchestrator: capacity, guardrails, and wiring. The model is configured here; other changes are made out-of-band (env / kubectl).',
      loadingSnapshot: 'Loading cluster snapshot…',
      snapshotError: 'Couldn\'t load the cluster snapshot',
      noSnapshotTitle: 'No snapshot',
      noSnapshotDescription: 'The orchestrator returned no system information.',
      capacityTitle: 'Capacity',
      unlimitedConcurrency: 'unlimited concurrency',
      activeMax: '{active} active / {max} max',
      capacityBarAria: 'Active runs against max concurrency',
      statRunning: 'Running',
      statScheduling: 'Scheduling',
      statQueued: 'Queued',
      statMaxConcurrent: 'Max concurrent',
      guardrailsTitle: 'Guardrails',
      runTimeoutLabel: 'Run timeout',
      jobTtlLabel: 'Job TTL',
      providerTitle: 'Provider',
      giteaEnabled: 'Gitea enabled',
      giteaDisabled: 'Gitea disabled',
      draftPrsLabel: 'Draft PRs',
      on: 'On',
      offDiffOnly: 'Off (diff-only)',
      giteaUrlLabel: 'Gitea URL',
      allowedHostsLabel: 'Allowed git hosts',
      unrestrictedAnyHost: 'unrestricted (any host)',
      allowedHostsHint: 'Project integrations may only target these hosts (ALLOWED_GIT_HOSTS). Empty = any host.',
      runnerTitle: 'Runner',
      imageLabel: 'Image',
      namespaceLabel: 'Namespace',
      launcherLabel: 'Launcher',
      persistentWorkspaceLabel: 'Persistent workspace',
      off: 'Off',
      authTitle: 'Auth',
      providerCount_one: '{count} provider',
      providerCount_other: '{count} providers',
      tokenOnly: 'token only',
      oauthProvidersLabel: 'OAuth providers',
      noneConsoleToken: 'none (console token only)',
      usersLabel: 'Users',
      versionTitle: 'Version',
      orchestratorLabel: 'Orchestrator',
      commitLabel: 'Commit',
      modelCatalogTitle: 'Model catalog',
      modelCount_one: '{count} model',
      modelCount_other: '{count} models',
      noModels: 'No models',
      modelCatalogHint: 'Register OpenAI-compatible endpoints, then authorize them per project. Runs are blocked for a project until it has at least one granted model.',
      loadingModelCatalog: 'Loading model catalog…',
      modelCatalogError: 'Couldn\'t load the model catalog',
      noModelsYet: 'No models yet — add one below.',
      keySet: 'key set',
      keyless: 'keyless',
      modelSaved: 'Model saved.',
      modelSaveError: 'Could not save the model.',
      modelRemoved: 'Model removed.',
      modelRemoveError: 'Could not remove the model.',
      nameLabel: 'Name',
      baseUrlLabel: 'Base URL',
      modelProviderLabel: 'Model (provider/model)',
      apiKeyLabel: 'API key',
      apiKeyPlaceholderClear: 'will be cleared (keyless)',
      apiKeyPlaceholderRotate: '•••••••• (blank = unchanged; type to rotate)',
      apiKeyPlaceholderNew: 'sk-…  (blank for keyless)',
      apiKeyHint: 'Stored encrypted. Never displayed after saving.',
      clearKeyLabel: 'Clear key (make this endpoint keyless)',
      noProjectsToAuthorize: 'No projects to authorize yet.',
      authorizedProjects: 'Authorized projects',
      grantUpdateError: 'Could not update the grant.',
      modelAdded: 'Model added.',
      modelAddError: 'Could not add the model.',
      apiKeyPlaceholderAdd: 'sk-…  (blank for keyless endpoints)',
      addModel: 'Add model',
    },
  },

  app: {
    linked: 'Linked your {provider} account.',
    linkTaken: 'That account is already linked to another user.',
    linkError: 'Could not link that account.',
    auth: {
      loginProviderDenied: 'The provider denied the sign-in request. Try again.',
      loginExchangeFailed: 'Sign-in could not complete (token exchange failed).',
      loginProfileFailed: 'Sign-in could not read your profile from the provider.',
      loginServerMisconfigured: 'Sign-in is not configured on the server.',
      loginServerError: 'The server hit an error completing sign-in.',
      loginFailed: 'Sign-in failed. Please try again.',
      enterToken: 'Enter the console token.',
      superseded: 'Superseded.',
      tokenRejected: 'Token rejected by the orchestrator.',
      lostOrchestrator: 'Lost the orchestrator — see setup steps.',
    },
  },

  components: {
    modelGate: {
      unverified: 'Couldn’t verify the model status — runs may fail if no model is available.',
      notConfigured: 'No model is available for this project, so runs can’t start.',
      grantLink: 'Grant a model on the Cluster page',
      contactAdmin: 'Contact a cluster administrator to grant a model to this project.',
    },
    prPanel: {
      stateOpen: 'Open',
      stateMerged: 'Merged',
      stateClosed: 'Closed',
      stateUnknown: 'Unknown',
      stateAria: 'Pull request state: {state}',
      reviewRequested: 'AI review requested.',
      reviewError: 'Could not request a review.',
      loading: 'Loading pull request…',
      loadError: 'Couldn\'t load the pull request',
      noPr: 'No pull request opened yet.',
      requestReview: 'Request AI review',
      reviewsTitle: 'Reviews',
      reviewsEmpty: 'No AI reviews yet.',
      hide: 'Hide',
      show: 'Show',
      reviewFailed: 'The review run failed before producing output.',
      reviewInProgress: 'Review in progress…',
    },
    states: {
      cannotReach: 'Cannot reach the orchestrator. Is it running?',
      somethingWrong: 'Something went wrong.',
      failedToLoad: 'Failed to load',
    },
    statusBadge: {
      queued: 'Queued',
      scheduling: 'Scheduling',
      running: 'Running',
      awaitingInput: 'Awaiting input',
      succeeded: 'Succeeded',
      failed: 'Failed',
      canceled: 'Canceled',
      blocked: 'Blocked',
      aria: 'Status: {status}',
    },
    gitMode: {
      legend: 'Git integration',
      modeAria: 'Git integration mode',
      readonlyLabel: 'Diff only',
      readonlyHint: 'A successful run produces a diff artifact only — nothing is pushed.',
      draftPrLabel: 'Pull request',
      draftPrHint: 'The trusted control plane pushes an isolated branch and manages a pull request. It never auto-merges; repository workflows may still run on push or PR events.',
      draftPrTitle: 'Successful runs deliver changes through a pull request.',
      readonlyTitle: 'Successful runs produce a diff artifact only — nothing is pushed.',
    },
    identity: {
      roleClusterAdmin: 'Cluster admin',
      roleProjectAdmin: 'Repository admin',
      signOut: 'Sign out',
      serviceNote: 'Authenticated with the console token — no linked identities.',
      session: 'Session',
      linkedAccounts: 'Linked accounts',
      noLinkedAccounts: 'No linked accounts yet.',
      linkAnother: 'Link another',
      link: 'Link {name}',
    },
    kanbanConnect: {
      startError: 'Could not start the connect flow.',
      connect: 'Connect with jtype',
      enterCode: 'Enter this code in jtype to authorize:',
      openJtype: 'Open jtype to authorize',
      waiting: 'Waiting for you to authorize in jtype…',
      connected: 'Connected — token set',
      failed: 'Connection failed — click Connect again.',
      expired: 'Connection expired — click Connect again.',
      unsupported: 'This jtype deployment doesn’t support one-click Connect — paste a token instead.',
      expiryExpired: 'expired',
      expiresInDays_one: 'expires in {count} day',
      expiresInDays_other: 'expires in {count} days',
    },
    projectSwitcher: {
      allProjects: 'All projects',
      noProjects: 'No projects yet',
    },
    modal: {
      close: 'Close dialog',
    },
  },


  members: {
    addedAs: '{name} added as {role}.',
    addError: 'Could not add member.',
    updateRoleError: 'Could not update role.',
    removed: '{name} removed.',
    removeError: 'Could not remove member.',
    searchPlaceholder: 'Search people by name…',
    searchAria: 'Search people to add',
    searching: 'Searching…',
    noMatches: 'No matching people.',
    adminTag: 'admin',
    roleForAddedAria: 'Role for the added member',
    roleForAria: 'Role for {name}',
    removeAria: 'Remove {name}',
    loading: 'Loading members…',
    loadError: 'Couldn\'t load members',
    roleOwner: 'owner',
    roleMember: 'member',
    roleViewer: 'viewer',
  },


  kanban: {
    enableTitle: 'Connect an Agent Board',
    enableBody: 'Choose an existing Board, execution model, and the columns that start, claim, and optionally complete work.',
    pluginRequired: 'Connect JType and select its workspace before attaching an Agent Board.',
    loadingAccountModels: 'Loading Account models…',
    accountModelsUnavailable: 'Account models could not be loaded.',
    accountModelRequired: 'Authorize at least one model for this Account before enabling Agent Board.',
    loadingBoards: 'Loading boards…',
    boardsUnavailable: 'Boards could not be loaded. Check the JType Plugin connection.',
    enable: 'Connect Agent Board',
    disable: 'Disconnect',
    triggerColumn: 'Trigger column',
	workColumn: 'Work in progress column',
    doneColumn: 'Completion column',
    noDoneColumn: 'Do not move completed cards',
    columnSettings: 'Automation columns',
    columnSettingsHint: 'Edit how cards start tasks and where completed work moves.',
    columnsUnavailable: 'Column options could not be loaded. Check the JType Plugin connection.',
    notConfiguredTitle: 'Kanban is not configured',
    notConfiguredMsg: 'A cluster administrator needs to configure the jtype integration before this board can open.',
    tlsInvalidTitle: 'JType certificate needs renewal',
    tlsInvalidMsg: 'JType’s HTTPS certificate could not be verified. Ask the administrator to renew or repair it, then retry.',
    unavailableTitle: 'Kanban is unavailable',
    unavailableMsg: 'The jtype service could not be reached. Retry when the service is available.',
    unauthorizedTitle: 'Kanban access needs attention',
    unauthorizedMsg: 'The current JType connection cannot read this Board. The Repository owner or a Cluster administrator needs to repair it.',
    workspaceNotFoundTitle: 'Kanban workspace was not found',
    workspaceNotFoundMsg: 'This Agent Board points to a JType workspace that is no longer available.',
    boardNotFoundTitle: 'This board could not be opened',
    boardNotFoundMsg: 'The board may have been deleted or renamed, or the integration lost access.',
    boardOpenDefaultMsg: 'The Board could not be opened right now. Retry, or ask the Repository owner to check the connection.',
    title: 'Agent Board',
    boardLabel: 'Board',
    openingBoard: 'Opening board…',
    loadingPolicy: 'Loading execution policy…',
    policyUnavailable: 'Execution policy could not be loaded.',
    policyTrigger: 'Starts jcode when Cards enter {column}',
	policyWork: 'Claims accepted Cards into {column}',
	policyWorkMissing: 'Accepted Cards are not moved into WIP',
    policyWriteback: 'Success comments and moves to {column}',
    policyCommentOnly: 'Results are written as Card comments',
    policyReady: 'Ready',
    policyBlocked: 'Blocked · {blocker}',
    policyBlockers: {
      binding_disabled: 'Automation disabled',
      plugin_unavailable: 'JType connection unavailable',
      event_feed_unavailable: 'JType event feed unavailable',
      bootstrap_unavailable: 'JType Card bootstrap unavailable',
      card_index_unavailable: 'JType Card index unavailable',
      card_read_unavailable: 'JType Card temporarily unreadable',
      card_unavailable: 'JType Card unavailable',
      board_validation_unavailable: 'JType board validation unavailable',
      board_drift: 'Board or Automation column changed',
      repository_not_configured: 'Repository not configured',
      repository_unavailable: 'Repository connection unavailable',
      provider_unavailable: 'Repository provider unavailable',
      runner_unavailable: 'Runner unavailable',
      run_unavailable: 'Linked Cloud Run unavailable',
      model_not_configured: 'Model not configured',
      model_not_authorized: 'Model is not authorized for the execution Account',
      model_authorization_unavailable: 'Model authorization could not be checked',
      execution_account_not_owner: 'Execution Account is no longer the Repository owner',
      work_column_not_configured: 'Work column is not configured',
      model_effort_unsupported: 'Reasoning effort unsupported',
    },
    executionsTitle: 'Cloud executions',
    loadingExecutions: 'Loading Cloud executions…',
    executionsUnavailable: 'Cloud executions could not be loaded.',
    noExecutions: 'No Cloud execution yet. Move this Card into the Starts jcode column to request one.',
    runWithAgent: 'Run with agent',
    agentRunActive: 'Agent run active',
    rerunDoneConfirm: 'This Card is already in Done. Run it again and move it back to the work column?',
    executionState: {
      received: 'Request received',
      blocked: 'Blocked',
      queued: 'Queued',
      running: 'Running',
      terminal: 'Finished',
      succeeded: 'Succeeded',
      failed: 'Failed',
      canceled: 'Canceled',
    },
    requestedByExternal: 'Requested by {actor}',
    projectOwner: 'Project owner',
    repositoryOwner: 'Repository owner',
    clusterAdmin: 'Cluster administrator',
    openRun: 'Open Run',
    writebackPending: 'Card writeback pending',
    writebackUnavailable: 'Source Card unavailable',
    executionSummary: {
      received: 'The Card request was received.',
      queued: 'The Run is queued.',
      running: 'The Run is applying the requested change.',
      succeeded: 'The Run completed successfully.',
      failed: 'The Run failed.',
      canceled: 'The Run was canceled.',
    },
    priorExecutions_one: '{count} prior execution',
    priorExecutions_other: '{count} prior executions',
    cardUnavailable: 'This Card no longer exists in JType. Cloud execution history is preserved.',
    loadEarlierExecutions: 'Load earlier executions',
    linkDisabledTitle: 'This Kanban automation link is disabled.',
    linkDisabledBody: 'The board is viewable, but card-triggered runs and writeback are disabled.',
  },

  onboarding: {
    setupStep1: 'Build the four local images',
    setupStep2: 'Deploy to the OrbStack cluster and wait for rollouts',
    setupStep3: 'Forward the orchestrator API to localhost:8080',
    probingEyebrow: 'Connecting',
    probingTitle: 'Bring the runtime into reach.',
    probingStory: 'The Console is checking whether an authenticated workflow can begin.',
    probingUtility: 'Connection setup',
    probingStatus: 'probing',
    setupEyebrow: 'Local setup',
    setupTitle: 'Bring the runtime into reach.',
    setupStory: 'The Console is ready. The orchestrator has not answered yet, so no authenticated workflow can begin.',
    setupUtility: 'Connection setup',
    setupStatus: 'unreachable',
    signinEyebrow: 'Your code. Your cluster.',
    signinTitle: 'Keep the work close to the system.',
    signinStory: 'jcode Cloud dispatches coding Tasks into infrastructure your team already controls.',
    signinUtility: 'Secure entry',
    signinStatus: 'sign in',
    welcomeEyebrow: 'Workspace ready',
    welcomeTitle: 'The first boundary is yours to set.',
    welcomeStory: 'You signed in first. jcode Cloud assigned the Cluster administrator role to this identity.',
    welcomeUtility: 'First-user setup',
    welcomeStatus: 'signed in',
    landingEyebrow: 'Session ready',
    landingTitle: 'The control plane is within reach.',
    landingStory: 'The console token established a Cluster administrator session for this browser.',
    landingUtility: 'Session boundary',
    landingStatus: 'authenticated',
    selfHosted: 'self-hosted',
    assignedRole: 'Assigned role',
    clusterAdministrator: 'Cluster administrator',
    adminSeparate: 'Cluster administration is separate from Repository ownership.',
    roleManageGrants: 'Manage model grants',
    roleConfigureConnections: 'Configure connections',
    roleViewCapacity: 'View capacity and policy',
    sessionBoundary: 'Session boundary',
    whatSignInEstablishes: 'What sign-in establishes',
    signInEstablishesBody: 'The orchestrator maps the provider identity to one jcode Cloud Account. Repository ownership and provider access are evaluated separately.',
    providerTokensServerSide: 'Provider tokens stay server-side and are never rendered into this page.',
    currentProbe: 'Current probe',
    whatConsoleKnows: 'What the Console knows',
    probeBody: 'This state reports only reachability. It does not infer whether Kubernetes, images, or credentials are healthy.',
    probeTarget: 'Target',
    probeResponse: 'Response',
    probeUnreachable: 'unreachable',
    probeWaiting: 'waiting',
    cantReachTitle: 'Can’t reach the orchestrator',
    setupLede1: 'The console proxies',
    setupLede2: 'to',
    setupLede3: ', but nothing answered. Bring the stack up, then this page moves on by itself.',
    recheckingNote: 'Re-checking every 3s — no refresh needed',
    checkNow: 'Check now',
    reasonRejected: 'The saved token was rejected — it may have been rotated. Enter the current one.',
    reasonExpired: 'Your session ended (expired or revoked). Sign in again.',
    reasonSignedOut: 'Signed out.',
    continueWith: 'Continue with {name}',
    signInHeading: 'Sign in',
    signInLedeNoProviders: 'No OAuth provider is configured. Use the console token the orchestrator was deployed with.',
    signInLedeProviders: 'Continue with your git provider to get a personal, per-user session.',
    advancedConsoleToken: 'Advanced: console token',
    consoleTokenLabel: 'Console token',
    consoleTokenHint: 'The CONSOLE_TOKEN the orchestrator was deployed with — cluster-admin. Stored locally in this browser.',
    signInWithToken: 'Sign in with token',
    welcomeFirstAdminTitle: 'You’re the first user — cluster admin',
    welcomeGreeting: 'Welcome, {name}',
    welcomeFirstAdminLede: 'You signed in first, so you’re now the cluster administrator: you can see every project and manage capacity. Everyone who joins after you starts as a regular user.',
    welcomeLede: 'You’re signed in. Create a project to point jcode Cloud at a repository, or open one you’ve been added to.',
    friend: 'friend',
    signedInAs: 'Signed in as {name}',
    getStarted: 'Get started',
    landingCardTitle: 'You’re in — cluster admin',
    landingLede: 'Signed in to this orchestrator:',
    principal: 'Principal',
    access: 'Access',
    accessClusterAdmin: 'cluster admin',
    accessMember: 'member',
    session: 'Session',
    sessionConsoleToken: 'console token',
    sessionUser: 'user session',
    identity: 'Identity',
    everythingHeadless: 'Everything runs headless in your cluster.',
    enterConsole: 'Enter console',
    connecting: 'Connecting to the orchestrator…',
    mobileHandoff: 'Signing you in on your phone…',
    mobileConsentTitle: 'Sign in on your phone',
    mobileConsentLede: 'You are already signed in as {name}. Tap below to complete sign-in on the mobile app.',
    mobileConsentContinue: 'Continue to app',
  },

  notFound: {
    title: 'This path ends here.',
    body: 'The page may have moved, or the link may describe a Repository or Task you can no longer access.',
    backToProjects: 'Back to Repositories',
  },

  projectDetail: {
    promptRequired: 'Describe the task for the agent.',
    sessionStarted: 'Session started.',
    startRunFailed: 'Failed to start run.',
    defaultModelUpdated: 'Default model updated.',
    defaultModelFailed: 'Could not set the default model.',
    deliveryPolicyUpdated: 'Pull request delivery policy updated.',
    deliveryPolicyFailed: 'Could not update the delivery policy.',
    runnerProfileUpdated: 'Runtime profile updated.',
    runnerProfileFailed: 'Could not set the runtime profile.',
    repoAdded: 'Repository “{name}” added.',
    addRepoFailed: 'Failed to add repository.',
    nameRequired: 'Name is required.',
    repoUrlRequired: 'Repository URL is required.',
    draftPrNeedsProviderUrl: 'Draft PR needs a provider repository URL.',
    loadingProject: 'Loading project…',
    loadFailedTitle: 'Couldn\'t load project',
    projects: 'Projects',
    cluster: 'Cluster',
    projectWorkspace: 'Project workspace',
    addService: 'Add service',
    deleteService: 'Delete service',
    deleteServiceAria: 'Delete {name} service',
    deleteServiceConfirm: 'Delete the “{name}” service? Active runs will be stopped first, then all runs, events, artifacts, automations, and workspace resources for this service will be permanently deleted. This cannot be undone.',
    serviceDeleted: 'Service “{name}” deleted.',
    deleteServiceFailed: 'Could not delete the service.',
    breadcrumb: 'Breadcrumb',
    backToWorkspace: 'Back to project workspace',
    projectSettings: 'Project settings',
    kanban: 'Agent Board',
    kanbanRetryTitle: 'Kanban links could not be loaded. Retry.',
    kanbanUnavailableRetry: 'Kanban unavailable · Retry',
    demoTag: 'DEMO',
    noRepositoriesYet: 'No services yet',
    repositoriesCount_one: '{count} repository',
    repositoriesCount_other: '{count} repositories',
    openProvider: 'Open {provider}',
    repoUrlUnresolved: 'The server could not resolve this provider repository\'s browser URL.',
    repositoryUnavailable: 'Repository unavailable',
    addRepoEmptyTitle: 'Add a service to get started',
    addRepoEmptyManage: 'A Service connects this Project to a Git repository and becomes the target for runs.',
    addRepoEmptyMember: 'A project owner needs to add a Service before runs can be dispatched.',
    firstServiceEyebrow: 'Project setup',
    firstServiceAction: 'Connect the first repository',
    firstServiceSetupTitle: 'Add the first service',
    firstServiceSetupDescription: 'Choose a repository. Once connected, it becomes the target for tasks and automations.',
    source: 'Source',
    directCredential: 'Direct (your credential)',
    gitProvider: 'Git provider',
    pickRepository: 'Pick a repository',
    searchRepositories: 'Search repositories…',
    loadingRepositories: 'Loading repositories…',
    listReposFailed: 'Couldn\'t list {source} repositories.',
    integrationSource: 'integration',
    addRepoByUrlInstead: ' Add the repository by URL below instead.',
    noRepositoriesMatch: 'No repositories match.',
    private: 'private',
    orAddByUrl: 'or add by URL',
    repositoryName: 'Repository name',
    repositoryUrl: 'Repository URL',
    addRepository: 'Add repository',
    memberNeedsIntegration: 'Connect an enabled GitHub, GitLab, or Gitea Project Plugin before adding a Service.',
    configureProjectPlugins: 'Configure project plugins',
    automationsMembersTitle: 'Automations are available to project members',
    automationsMembersDesc: 'You can view task history, but a project member must manage schedules and provider events.',
    automationsNeedServiceTitle: 'Automations need a service',
    automationsNeedServiceDesc: 'Connect a repository first; schedules and provider events are scoped to a service.',
  },

  plugins: {
    title: 'Plugins',
    projectPlugin: 'Project plugin',
    intro: 'Connect a provider once for this Project. Healthy enabled plugins are available to every Project task.',
    readOnly: 'Only a Project owner or Cluster administrator can change Plugin connections.',
    loading: 'Loading Plugins…',
    loadError: 'Could not load Plugins.',
    notConnected: 'Not connected',
    connect: 'Connect',
    connectError: 'Could not start the Provider connection.',
    summary: '{services} Services · {automations} Automations',
    back: 'Back to Plugins',
    identity: 'Connected identity',
    scopes: 'Granted access',
    noScopes: 'No Provider access is currently granted.',
    resources: 'Resources',
    noResources: 'No project resources are bound yet.',
    automationSummary: 'Automations',
    openAutomations: 'Open Automations',
    audit: 'Connection audit',
    noAudit: 'No audit events are available.',
    reconnect: 'Reconnect',
    stableId: 'Stable ID: {id}',
    consentRecorded: 'Consent {version} · {time}',
    unknown: 'unknown',
    resourcesLoadError: 'Provider resources could not be listed.',
    boundWorkspace: 'Bound workspace',
    selectWorkspace: 'Select workspace…',
    workspaceSetupHint: 'Selecting a workspace finishes the JType Plugin setup and enables it.',
    workspace: 'workspace',
    columns: '{count} columns',
    private: 'private',
    public: 'public',
    defaultBranchUnknown: 'default branch unknown',
    services: 'Services',
    noServices: 'No Services are bound to this Plugin.',
    noAutomations: 'No Automations depend on this Plugin.',
    auditLoadError: 'Plugin audit history could not be loaded.',
    auditLoading: 'Loading audit history…',
    impactLoading: 'Loading impact…',
    impactLoadError: 'Impact could not be loaded.',
    impactSummary: '{services} Services and {automations} Automations will be permanently deleted.',
    forceUninstall: 'Force local removal if only Provider webhook cleanup is failing. This may leave an external hook behind.',
    trigger: {
      scm: 'SCM event',
      kanban: 'Kanban column',
      cron: 'Cron schedule',
    },
    systemActor: 'System',
    enable: 'Enable Plugin',
    disable: 'Disable Plugin',
    uninstall: 'Uninstall Plugin',
    uninstallHint: 'Uninstalling permanently removes the dependent Services and Automations after external cleanup.',
    uninstallTitle: 'Uninstall {provider}?',
    uninstallConfirm: 'This cannot be undone. External webhook cleanup may continue after the local Plugin is removed.',
    uninstallType: 'Type UNINSTALL to confirm',
    invalidProvider: 'This Provider plugin does not exist.',
    consentTitle: 'Connect {provider}',
    consentIntro: 'Review the Project-wide access that this connection gives to jcode Cloud before continuing to {provider}.',
    consentScope: 'The Provider will be asked for the code, branch, pull request, issue, comment, check, tag, release, and webhook access required by this Plugin.',
    consentShared: 'The token becomes a shared Project credential; it is not personal to the installer.',
    consentTasks: 'All Project tasks receive every enabled Plugin, including this one.',
    consentPersistence: 'This connection continues after the installer leaves the Project until it is disconnected or revoked by the Provider.',
    consentPublic: 'On public repositories, an @jcode comment can start a task that receives all enabled Project Plugin credentials.',
    consentAcknowledge: 'I understand and approve this Project-wide access.',
    continueToProvider: 'Continue to Provider',
    incompleteResponse: 'The Provider returned an incomplete connection response.',
    providerInstance: 'Provider instance',
    configuredClusterInstance: 'Configured cluster instance',
    requestedScopes: 'Requested scopes',
    githubChooseInstallation: 'Choose a GitHub App Installation',
    githubChooseInstallationHint: 'Select an Installation to inspect its actual permissions before consenting. The selection is explicit for this Project and is never reused automatically.',
    githubInstallationsLoading: 'Loading GitHub Installations…',
    githubInstallationsLoadError: 'GitHub Installations could not be listed.',
    githubInstallationSummary: '{target} · {selection} repositories',
    githubTarget: { organization: 'Organization', user: 'User' },
    githubSelection: { selected: 'selected', all: 'all' },
    githubInstallationsEmpty: 'No manageable GitHub App Installations were found. Install or adjust the GitHub App on GitHub, then retry.',
    githubActualPermissions: 'Actual permissions for {account}',
    githubPermissionsAcknowledge: 'I reviewed these actual GitHub App permissions and accept the Project-wide credential risks above.',
    githubConnectInstallation: 'Connect this Installation',
    jtypeApprove: 'Approve in JType',
    jtypeApproveHint: 'Use code <code>{code}</code>. This dialog will keep checking until JType confirms the grant.',
    jtypeOpenConsent: 'Open JType consent page',
    jtypeStatusLoadError: 'JType connection status could not be checked.',
    connectionStatusLabel: 'Status: {status}',
    connectionStatus: {
      pending: 'pending',
      complete: 'complete',
      expired: 'expired',
      denied: 'denied',
      unsupported: 'unsupported',
      checkFailed: 'could not check status',
    },
    coarseScope: {
      gitlab: 'GitLab’s coarse api scope can authorize broader read/write API operations than this Plugin normally needs, including repository settings allowed to your external role. jcode has no command allowlist that technically prevents every destructive API call.',
      gitea: 'Gitea’s coarse write:repository scope may authorize repository settings and destructive operations beyond normal task workflows, depending on the instance version and your external role. jcode has no command allowlist.',
      jtype: 'JType full scope authorizes every supported read/write operation in the selected cloud workspace, not only Kanban triggers.',
    },
    healthError: {
      jtypeStartFailed: 'JType device authorization could not be started.',
      webhookCleanupFailed: 'Provider webhook cleanup failed. Retry uninstall, or explicitly force local removal and accept that an external hook may remain.',
      runtimeCleanupFailed: 'Runtime cleanup failed. Retry uninstall after the cluster is healthy.',
      oauthRefreshFailed: 'OAuth access expired and refresh failed. Reconnect this Plugin.',
      providerConfigChanged: 'The Cluster Provider configuration changed. Reconnect this Project Plugin.',
    },
    apiError: {
      githubAppNotConfigured: 'The GitHub App is not fully configured. Ask a Cluster administrator to add its App ID, private key, and webhook secret.',
      githubIdentityRequired: 'Sign in with the GitHub account that manages this App Installation.',
      githubInstallationForbidden: 'The current GitHub account cannot manage the selected App Installation.',
      githubAppError: 'GitHub could not validate the selected App Installation. Try again.',
      consentScopeChanged: 'The GitHub App permissions changed. Review the current permissions and consent again.',
      providerNotConfigured: 'This Provider Plugin is not configured or enabled on the Cluster.',
      credentialUnavailable: 'The Plugin credential is unavailable. Reconnect the Plugin.',
      reconnectRequired: 'The Plugin configuration changed or its authorization expired. Reconnect the Plugin.',
      connectExpired: 'The connection request expired. Start the connection again.',
      workspaceUnavailable: 'The selected JType workspace is not available to this authorization.',
      workspaceRequired: 'Select a JType workspace before enabling this Plugin.',
      webhookCleanupFailed: 'Provider webhook cleanup failed. Retry uninstall or explicitly force local removal.',
      runtimeCleanupFailed: 'Runtime cleanup failed. Retry after the Cluster is healthy.',
      connectUnsupported: 'This Provider connection flow is not supported yet.',
      encryptionUnavailable: 'The Cluster encryption key is not configured. Ask a Cluster administrator.',
      consentRequired: 'Review and accept the current Project Plugin consent before connecting.',
      providerUnavailable: 'The Provider could not complete this request. Check its availability and permissions, then retry.',
      generic: 'The Plugin operation could not be completed. Try again.',
    },
    auditEvent: {
      consent_accepted: 'Consent accepted',
      connected: 'Connected',
      reconnected: 'Reconnected',
      reconnect_started: 'Reconnect started',
      configuration_changed: 'Configuration changed',
      uninstall_cleanup_failed: 'Uninstall cleanup failed',
      uninstalled: 'Uninstalled',
      force_uninstalled: 'Force uninstalled',
    },
    status: {
      not_connected: 'Not connected',
      connecting: 'Connecting',
      enabled: 'Enabled',
      disabled: 'Disabled',
      action_required: 'Action required',
      uninstalling: 'Uninstalling',
      error: 'Error',
    },
  },

  automationEditor: {
    loading: 'Loading Automation…',
    loadError: 'Could not load Automation.',
    eyebrow: 'Repository Automation',
    createTitle: 'Create Automation',
    editTitle: 'Edit Automation',
    subtitle: 'Bind one strongly typed trigger to this Repository.',
    viewerWarning: 'Viewers can inspect but cannot save Automations.',
    task: 'Task',
    name: 'Name',
    service: 'Repository',
    selectService: 'Select Repository…',
    serviceUnavailable: 'Repository unavailable',
    model: 'Model',
    selectModel: 'Select a model…',
    effort: 'Reasoning effort',
    effortAuto: 'Auto',
    effortLow: 'Low',
    effortMedium: 'Medium',
    effortHigh: 'High',
    effortHint: 'Available because this model advertises reasoning support.',
    promptTemplate: 'Prompt template',
    enabled: 'Enabled',
    ignoreJcode: 'Ignore events created by jcode',
    trigger: 'Trigger',
    scm: 'SCM',
    cron: 'Cron',
    selectGitService: 'Connect a GitHub, GitLab, or Gitea Repository.',
    capabilitiesLoadError: 'Provider capabilities could not be loaded.',
    branchFilter: 'Branch filter',
    branchPlaceholder: 'main or feature/*',
    branchHint: 'Available for branch-carrying Push, PR, and Check events.',
    pathPattern: 'Path pattern',
    pathHint: 'Available only when every selected event is push.updated.',
    conclusion: 'CI conclusion',
    conclusionHint: 'Available only when every selected event is check.completed.',
    events: 'Events',
    moreEvents: 'More events',
    thisProvider: 'this provider',
    eventUnavailable: 'Not supported by {provider}{version}.',
    cronExpression: 'Cron expression',
    cronHint: 'Five-field cron expression. The minimum interval is enforced by the server.',
    outputMode: 'Output',
    outputRun: 'Create a Run directly',
    outputCard: 'Create a jtype Card, then use Agent Board',
    outputHint: 'Card output preserves the jtype Work Item and uses the normal Kanban claim and writeback loop.',
    openBoardSettings: 'Open Agent Board settings',
    outputCardUnavailable: 'Connect a healthy Agent Board before selecting Card output.',
    create: 'Create Automation',
    save: 'Save Automation',
    review: {
      eyebrow: 'GitHub code review',
      title: 'Review pull requests',
      subtitle: 'Turn on useful, native reviews without teaching the team a new workflow.',
      defaultName: 'Pull request review',
      setup: 'Review setup',
      automaticTitle: 'Automatic by default',
      automaticBody: 'The App reviews a pull request when it is ready and reviews each new commit.',
      repeatTitle: 'Repeat from GitHub',
      repeatBody: 'Paste this command in any pull request comment. GitHub may not autocomplete custom Apps after @, but the literal command is supported.',
      focus: 'Review focus (optional)',
      focusPlaceholder: 'For example: pay special attention to authorization boundaries.',
      focusHint: 'The reviewer always checks correctness, security, reliability, data loss, and regressions.',
      when: 'When to review',
      readyTitle: 'Ready pull requests',
      readyBody: 'Review newly opened pull requests and drafts when they become ready.',
      updatesTitle: 'New commits',
      updatesBody: 'Run a fresh review when the pull request head changes.',
      draftsTitle: 'Include drafts',
      draftsBody: 'Usually leave this off so authors can finish their first pass.',
      create: 'Turn on reviews',
      save: 'Save review settings',
    },
    validation: {
      noPermission: 'You do not have permission to edit Automations.',
      required: 'Name, Repository, model, and task Prompt are required.',
      eventRequired: 'Select at least one event supported by this Repository provider.',
      cronRequired: 'Cron expression is required.',
      cardOutputUnavailable: 'Card output requires a healthy Agent Board policy.',
    },
    apiError: {
      overlap: 'Another Automation already uses one of the selected SCM events for this Repository.',
      webhook: 'The Automation was saved, but the Provider webhook could not be synchronized. Check the Plugin connection and try again.',
      pluginUnavailable: 'The selected Repository connection is unavailable or does not support this trigger.',
      modelUnavailable: 'The selected model is no longer available to this Account. Choose another model.',
      modelRequired: 'Choose a model authorized for this Account.',
      effortUnsupported: 'The selected model does not support reasoning effort. Use Auto or choose a reasoning model.',
      generic: 'The Automation could not be saved. Try again.',
    },
  },

  projectSettings: {
    navGeneral: 'General',
    navMembers: 'Members',
    navPlugins: 'Plugins',
    navModels: 'Model access',
    navApiKeys: 'API keys',
    envInvalidName: '“{key}” is not a valid environment variable name.',
    envReserved: '“{key}” is reserved by the orchestrator and can’t be set.',
    projectUpdated: 'Project “{name}” updated.',
    updateFailed: 'Failed to update project.',
    projectDeleted: 'Project “{name}” deleted.',
    deleteFailed: 'Failed to delete project.',
    eyebrow: 'Project administration',
    title: 'Settings',
    subtitle: 'Manage the project container. Repository behavior remains scoped to each service.',
    navAria: 'Project settings sections',
    generalDesc: 'Project identity and execution guardrails.',
    projectName: 'Project name',
    projectNameHintPage: 'Repository branch and git mode are configured per service.',
    executionGuardrails: 'Execution guardrails',
    guardrailBlankHint: 'Leave a limit blank to inherit the cluster default.',
    maxConcurrent: 'Max concurrent runs',
    clusterDefaultPlaceholder: 'cluster default',
    runTimeout: 'Run timeout (seconds)',
    injectedEnv: 'Injected environment',
    injectedEnvHintPage: 'Merged into every run. System variables are reserved.',
    removeVariable: 'Remove variable',
    addVariable: 'Add variable',
    membersTitle: 'Members and permissions',
    membersDesc: 'Choose who can view, run, and administer this project.',
    pluginsTitle: 'Plugins',
    pluginsDesc: 'Project-shared source control and Kanban connections.',
    modelsDesc: 'Models currently available to sessions in this project.',
    apiKeysTitle: 'Project API keys',
    apiKeysDesc: 'Revocable credentials for API-triggered automation.',
    dangerTitle: 'Danger zone',
    dangerDesc: 'Permanent, destructive project actions.',
    deleteProject: 'Delete project',
    deleteHintPage: 'Permanently removes this project and all of its runs, events, and artifacts.',
    deleteForGood: 'Delete for good?',
    savebarHint: 'Project settings are saved independently from service settings.',
    saveChanges: 'Save changes',
    loadingModelAccess: 'Loading model access…',
    modelAccessLoadError: 'Model access could not be loaded. Retry from the project workspace.',
    noModelConfigured: 'No model is configured for this project. Ask a cluster administrator to grant one.',
    granted: 'Granted',
    envFallbackActive: 'Cluster environment model fallback is active.',
    models: {
      ownedTitle: 'Project model providers',
      ownedDescription: 'Connect this project’s own providers and choose which models it can run.',
      addProvider: 'Add provider',
      providersSummary: '{providers} providers · {models} models',
      noProviders: 'No project model providers yet.',
      noProvidersHint: 'Add a provider to give this project its own models.',
      enableAria: 'Enable {name}',
      disableAria: 'Disable {name}',
      editModelAria: 'Edit {name}',
      deleteModelAria: 'Remove {name}',
      removeModelConfirm: 'Remove {name}?',
      modelRemoved: 'Model removed.',
      removeModelError: 'Could not remove the model.',
      updateModelError: 'Could not update the model.',
      clearHeadersAction: 'Remove configured headers',
      clearHeadersPending: 'Configured headers will be removed on save · click to undo',
      editDialogTitle: 'Edit model · {name}',
      saveModel: 'Save model',
      modelSaved: 'Model saved.',
      saveModelError: 'Could not save the model.',
      availableTitle: 'Available models',
      defaultTitle: 'Project default model',
      defaultDescription: 'Used when an Automation or Service does not choose a more specific model.',
      noDefault: 'No project default',
      availableOwnerHint: 'Every model this project can run — its own plus any granted by a cluster administrator.',
      availableMemberHint: 'Models a cluster administrator or project owner has made available to this project.',
    },
    name: 'Name',
    guardrails: 'Guardrails',
    apiKeyCreated: 'API key “{name}” created.',
    apiKeyCreateFailed: 'Could not create the API key.',
    apiKeyRevoked: 'API key revoked.',
    apiKeyRevokeFailed: 'Could not revoke the API key.',
    apiKeyIntro1: 'A project-scoped key authenticates as ',
    apiKeyIntro2: ' and can trigger runs and read this project only — never another project, never this project\'s settings or members, and never the cluster-admin surface. Use it for external/CI automation instead of the cluster-wide console token.',
    apiKeysEmpty: 'No API keys yet — create one below.',
    apiKeyNameHint: 'Helps you tell keys apart later — pick something identifying, like the CI job that will use it.',
    createKey: 'Create key',
    apiKeyRevealTitle: '“{name}” created',
    apiKeyRevealHint: 'Shown once — copy it now. It cannot be displayed again; if you lose it, revoke this key and create a new one.',
    statusRevoked: 'revoked',
    statusActive: 'active',
    createdAt: 'Created {time}',
    lastUsed: ' · last used {time}',
    neverUsed: ' · never used',
    revoke: 'Revoke',
  },

  projectWorkspace: {
    railServicesAria: 'Project services',
    projectEyebrow: 'Project',
    serviceCount_one: '{count} service',
    serviceCount_other: '{count} services',
    servicesHeading: 'Services',
    noServiceConnected: 'No service connected yet.',
    workspaceAria: '{projectName} workspace',
    tabsAria: 'Project workspace sections',
    tabTasks: 'Tasks',
    tabAutomations: 'Automations',
    tabServiceSettings: 'Service settings',
  },

  taskComposer: {
    eyebrow: 'New task',
    heading: 'Start a session in {name}',
    isolation: 'Runs in an isolated workspace',
    messageAria: 'Message',
    placeholder: 'Describe the work to complete…',
    permissionModeAria: 'Permission mode',
    permissionModeTitle: 'Full access auto-approves the agent; Ask before actions pauses it for your approval in the timeline.',
    fullAccess: 'Full access',
    askBeforeActions: 'Ask before actions',
    session: 'Session',
    modelAria: 'Model',
    serviceDefault: 'Repository default',
    serviceDefaultWithModel: 'Repository default · {model}',
    branchAria: 'Base branch',
    branchDefault: 'default',
	branchLoading: 'Loading branches…',
    branchUnavailable: 'Branches could not be refreshed. Resolve the Plugin connection, then try again.',
    effortAria: 'Reasoning effort',
    effortAuto: 'Effort · Auto',
    effortLow: 'Effort · Low',
    effortMedium: 'Effort · Medium',
    effortHigh: 'Effort · High',
    add: 'Add',
    addMenu: 'Add to task',
    goalMode: 'Goal mode',
    goalPlaceholder: 'Describe the objective to keep working toward…',
    goalModeHint: 'The next task starts a persistent Goal.',
    disableGoalMode: 'Turn off Goal mode',
    attachments: 'Attachments',
    addAttachments: 'Add attachments',
    removeAttachment: 'Remove {name}',
    attachmentTooMany: 'You can attach at most {max} files.',
    attachmentTooLarge: '{name} is larger than 25 MiB.',
    attachmentTotalTooLarge: 'Attachments can total at most {max} MiB per Run.',
    attachmentUploadFailed: 'The attachments could not be uploaded.',
    send: 'Send',
  },

  automationExecutions: {
    loading: 'Loading Automation…',
    loadError: 'Could not load Automation.',
    back: 'Back to Automations',
    cardOutput: 'Card output',
    runOutput: 'Direct Run output',
    runNow: 'Run now',
    runNowError: 'The execution could not be accepted. Retry uses the same idempotency key.',
    history: 'Execution history',
    loadingHistory: 'Loading execution history…',
    historyError: 'Could not load execution history.',
    empty: 'No executions yet.',
    loadMore: 'Load older executions',
    select: 'Select an execution to inspect it.',
    selected: 'Selected execution',
    execution: 'Execution',
    trigger: 'Trigger',
    kind: 'Kind',
    requested: 'Requested by',
    accountable: 'Accountable to',
    notApplicable: 'Not applicable',
    unattributed: 'Unattributed',
    output: 'Output',
    expected: 'Expected',
    cardThenRun: 'jtype Card → Kanban Run',
    directRun: 'Direct Run',
    actual: 'Actual',
    writeback: 'Writeback',
    usage: 'Usage',
    usageUnavailable: 'Unavailable',
    filter: { all: 'All', blocked: 'Blocked', running: 'Running', terminal: 'Terminal' },
    state: {
      accepted: 'Accepted', ignored: 'Ignored', duplicate: 'Duplicate',
      superseded: 'Superseded', blocked: 'Blocked', queued: 'Queued',
      running: 'Running', terminal: 'Terminal',
    },
    outcome: { succeeded: 'Succeeded', failed: 'Failed', canceled: 'Canceled' },
    repair: {
      project_owner: 'A Project owner can repair this dependency.',
      repository_owner: 'The Repository owner can repair this dependency.',
      cluster_admin: 'A Cluster administrator must repair this dependency.',
      requester: 'The requester must repair this dependency.',
    },
    title: {
      blocked: 'Blocked before output',
      ignored: 'Trigger intentionally ignored',
      card: 'Card output',
      run: 'Run output',
    },
  },

  projectAutomations: {
    eyebrow: 'Repository automation',
    title: 'Automations',
    subtitle: 'Create SCM and scheduled work for this Repository. Agent Board is configured from the Repository header.',
    loading: 'Loading Automations…',
    loadError: 'Could not load Automations.',
    new: 'New automation',
    noServices: 'Connect a Repository before creating an Automation.',
    filters: 'Automation filters',
    all: 'All',
    empty: 'No Automations match this view.',
    edit: 'Edit',
    delete: 'Delete',
    back: 'Back to Automations',
    newTitle: 'New Automation',
    editTitle: 'Edit Automation',
    name: 'Name',
    triggerLabel: 'Trigger type',
    cron: 'Cron expression',
    action: 'SCM event',
    column: 'Trigger column',
    prompt: 'Task instructions',
    incomplete: 'Complete every required field before saving.',
    create: 'Create Automation',
    save: 'Save changes',
    trigger: { scm: 'SCM event', kanban: 'Kanban column', cron: 'Cron schedule' },
    enabled: 'enabled',
    disabled: 'disabled',
    toggleLabel: '{name}: {status}',
    review: {
      turnOn: 'Review pull requests',
      manage: 'Review settings',
      rowSummary: 'High-confidence findings on changed lines, posted by the GitHub App.',
      native: 'GitHub native review',
    },
    error: {
      modelUnavailable: 'No model could be selected when this event was received. Authorize a model for the Account; if several are available, set a Repository default. A successful trigger clears this historical error.',
      modelNotSelected: 'Several models are available, but this Repository has no default model. Set one in Repository settings.',
      modelNotConfigured: 'No model is authorized for this Account. Ask a Cluster administrator to authorize one.',
      modelTemporary: 'The model configuration could not be read because of a temporary internal error. Retry the trigger.',
      triggerUnavailable: 'This Automation’s trigger configuration is unavailable. Re-save the Automation.',
      serviceUnavailable: 'This Automation’s Repository is unavailable.',
      repositoryUnavailable: 'This Repository connection is unavailable. Reconnect the Provider.',
      runCreateFailed: 'The event matched, but the Automation Run could not be created.',
      invalidCron: 'The Cron expression is invalid: {expression}',
      dispatchFailed: 'The scheduled Automation could not create a Run.',
      webhookReconcileFailed: 'The SCM webhook could not be synchronized. Verify the Plugin credential and Provider hook permissions, then save the Automation again.',
    },
  },


  settingsPanel: {
    emptyTitle: 'Settings need a Repository',
    emptyDescription: 'Connect a repository before configuring its model policy.',
    eyebrow: 'Repository settings',
    description: 'Execution policy for this Repository. Provider connections are managed separately.',
    source: 'Source',
    provider: 'Provider',
    defaultBranch: 'Default branch',
    gitMode: 'Git mode',
    gitModeDraftPr: 'Pull request',
    gitModePullRequest: 'Pull request',
    gitModeReadOnly: 'Read only',
    deliveryPolicyEyebrow: 'Delivery policy',
    deliveryPolicyTitle: 'Review readiness',
    deliveryPolicyDescription: 'Lifecycle aware creates one-shot PRs ready for review and keeps sessions draft until Finish. Changing this may notify reviewers and trigger repository workflows.',
    deliveryPolicyAria: 'Pull request completion policy',
    lifecycleAware: 'Lifecycle aware',
    alwaysDraft: 'Always draft',
    modelPolicyEyebrow: 'Model policy',
    modelPolicyTitle: 'Repository default model',
    modelPolicyDescription: 'This is used only when a task composer keeps the per-run choice at Repository default.',
    modelsLoading: 'Loading Account model access…',
    modelsUnverified: 'Couldn’t verify this Account’s model access. Do not change the default until the model catalog is available.',
    retryModelCheck: 'Retry model check',
    defaultModelAria: 'Default model for this repository',
    noDefault: 'No default',
    noModelGranted: 'No model has been authorized for this Account. A Cluster administrator must authorize one before a Repository default can be selected.',
	runtimePolicyEyebrow: 'Runtime policy',
	runtimePolicyTitle: 'Runner environment',
	runtimePolicyDescription: 'Choose an administrator-maintained, immutable toolchain profile for every Run on this Repository.',
	runnerProfileAria: 'Runner environment for this repository',
	runtimeProfilesUnavailable: 'Runtime profiles could not be loaded. The current Repository setting remains unchanged.',
  },

  webhook: {
    errSync: 'Could not synchronize the provider webhook. Try again or contact a cluster administrator.',
    eyebrowReview: 'PR review webhook',
    unavailableTitle: 'Provider events need a provider-backed repository',
    pathOrUrlNote: 'is a path or raw URL, so it cannot receive pull-request or merge-request comment events.',
    readonlyTitle: 'Automation is read-only for viewers',
    readonlyBody: 'A project member can connect {provider} and synchronize this repository’s review webhook.',
    oauthNotConfiguredTitle: '{provider} OAuth is not configured in this cluster',
    oauthNotConfiguredBody: 'Ask a cluster administrator to configure {provider} OAuth and the webhook receiver. No fallback credential will be used.',
    serviceTitle: 'A signed-in project member must authorize {provider}',
    serviceBody: 'The console-token session has no personal OAuth identity. Sign in with a project member account to synchronize this webhook.',
    eyebrowProvider: 'Provider webhook',
    connectTitle: 'Connect {provider} for PR review commands',
    connectBodyPre: 'Connect the account that administers',
    connectBodyPost: '. jcode will request OAuth permission for this repository; it never asks you to paste a personal access token here.',
    connectCta: 'Connect {provider} with OAuth',
    readyTitle: '{provider} PR review commands',
    readyBodyPre: 'Sync registers the provider’s comment webhook for',
    readyBodyMid: ' using your {provider} OAuth account. A collaborator can then start a review with ',
    readyBodyPost: '. It is safe to run again when the repository changes.',
    oauthConnected: 'OAuth is connected.',
    synchronizing: 'Synchronizing the webhook…',
    setupReady: 'Webhook setup is ready.',
    syncedTo: 'webhook is synced to',
    syncButton: 'Sync {provider} webhook',
    reconnectOauth: 'Reconnect OAuth',
  },

  runActivity: {
    eyebrow: 'Activity',
    title: 'Recent tasks',
    filtersAria: 'Filter recent tasks',
    filterAll: 'All',
    filterSessions: 'Sessions',
    filterReviews: 'Reviews',
    loadingTasks: 'Loading tasks…',
    errorTitle: 'Couldn\'t load tasks',
    emptyTitleAll: 'No tasks yet',
    emptyTitleFiltered: 'No {filter} for this Repository',
    emptyDescDispatch: 'Dispatch your first task using the composer above.',
    emptyDescNone: 'No tasks have been dispatched in this project yet.',
    emptyDescFiltered: 'Try another filter or choose a different Repository.',
    runAria: '{kind}: {summary} — {status}',
    retryTitle: 'Retry of an earlier run',
    retryBadge: 'retry',
  },

  projectSettingsAction: {
    label: 'Project settings',
  },

  codeReviewsPage: {
    eyebrow: 'Independent workflow',
    title: 'Code reviews',
    description: 'Review runs across your Repositories, kept separate from implementation tasks.',
    createEyebrow: 'New review',
    createTitle: 'Start a code review',
    createDescription: 'Choose a Repository and a pull request created by a completed Cloud task.',
    loadingSources: 'Loading reviewable pull requests…',
    sourcesError: 'Reviewable pull requests could not be loaded.',
    noRepositories: 'No Repository is available to this account.',
    connectRepository: 'Review Git account access',
    repositoryLabel: 'Repository',
    pullRequestLabel: 'Pull request',
    noReviewablePr: 'No Cloud-created pull request is ready for review.',
    noReviewablePrDescription: 'Run a Repository task that opens a pull request, then return here.',
    openWorkHome: 'Open Work Home',
    openPullRequest: 'Open pull request',
    createAction: 'Create code review',
    createSuccess: 'Code review started.',
    createError: 'Could not start the code review.',
    emptyTitle: 'No code reviews yet',
    emptyDescription: 'Review runs from every Repository will appear here.',
  },
  accountHeader: {
    location: 'Workspace location',
    account: 'Account',
    menu: 'Account menu',
    codeReviews: 'Code reviews',
    settings: 'Account settings',
    clusterSettings: 'Cluster settings',
    admin: 'Admin',
    signOut: 'Sign out',
  },
  accountSettings: {
    back: 'Back to work home',
    eyebrow: 'Account',
    title: 'Account settings',
    description: 'Your profile, model access, linked Git accounts, usage, and preferences apply across every Repository and jcode Desktop.',
    tabsAria: 'Account settings sections',
    profileTab: 'Profile',
    gitAccountsTab: 'Git accounts',
    modelsTab: 'Models',
    usageTab: 'Usage',
    preferencesTab: 'Preferences',
    profileTitle: 'Account profile',
    profileDescription: 'This is the identity used to execute Repository tasks and own conversations.',
    displayName: 'Display name',
    accountId: 'Account ID',
    role: 'Role',
    clusterAdministrator: 'Cluster administrator',
    member: 'Member',
    executionIdentity: 'Execution identity',
    repositoryOwnerDefault: 'Repository owner by default',
    currentAccount: 'Current account',
    sessionAccount: 'Session account',
    gitAccountsTitle: 'Git accounts',
    gitAccountsDescription: 'Repositories visible to these linked accounts appear directly in the Work Home context picker.',
    repositoryAccessUnavailable: 'Repository access is unavailable for this account.',
    connected: 'Connected to this account',
    reauthorize: 'Reauthorize {provider}',
    linkProvider: 'Link {provider}',
    authorizeRepositories: 'Authorize repositories for this account',
    checkingRepositoryAccess: 'Checking Repository access…',
    repositoryAccessUnavailableTitle: 'Repository access unavailable',
    modelsTitle: 'Models and providers',
    modelsDescription: 'Configure personal providers and choose the models available to your tasks.',
    loadingModels: 'Loading account models…',
    modelAccessUnavailable: 'Model access unavailable',
    noModels: 'No model is authorized for your account. Contact a Cluster administrator.',
    modelAuthorized: 'Authorized for your account',
    manageAuthorizations: 'Manage account authorizations in Cluster settings',
    preferencesTitle: 'Preferences',
    preferencesDescription: 'Cloud and Desktop use the same product language and visual preferences where supported.',
    language: 'Language',
    languageDescription: 'Change the interface language.',
    appearance: 'Appearance',
    appearanceDescription: 'Use light or dark theme.',
  },
  repositories: {
    openRepository: 'Open repository {name}',
    toggleConversations: 'Toggle conversations for {name}',
    conversationSection: 'Conversation',
    navigationUnavailable: 'This Repository is unavailable. Check your Git account access or choose another Repository.',
    remoteUnavailable: 'This Remote device is unavailable. Reconnect it or choose another device.',

    eyebrow: 'Your code',
    title: 'Repositories',
    description: 'One Repository is one Agent workspace, with its own Board, tasks, settings, and code reviews.',
    composerEyebrow: 'Account workspace', composerTitle: 'What should we code next?',
    composerDescription: 'Choose any repository your linked account can access and start a task directly.',
    remoteComposerDescription: 'Continue on an online jcode device with the same conversation UI.',
    contextAria: 'Repository or Remote context {context}',
    repositoryFallback: 'Repository',
    remoteBack: 'Back to repositories',
    remoteConnection: 'Remote connection',
    remoteChooseDevice: 'Choose an online jcode device',
    onlineDevices: 'Online devices',
    jcodeDevice: 'jcode device',
    online: 'online',
    connectNewDevice: 'Connect new device',
    connectNewDeviceDescription: 'Run jcode login and complete encrypted pairing',
    pickerSearchAria: 'Search repositories',
    pickerSearchPlaceholder: 'Search repositories…',
    gitRepositories: 'Git repositories',
    pickerSearchError: 'Repository search failed. Change the query or try again.',
    pickerNoMatch: 'No repositories match “{query}”.',
    remoteConnectionAria: 'Remote connection {count} online',
    remoteOnlineCount: '{count} jcode devices online',
    searchingRepositories: 'Searching repositories',
    conversationRailAria: 'Conversations',
    conversationRailWorkHome: 'Work Home',
    conversationRailNew: 'New conversation',
    conversationRailSearchAria: 'Search conversations',
    conversationRailSearchPlaceholder: 'Search conversations…',
    conversationRailByRepository: 'Recent repositories',
    conversationRailCollapse: 'Collapse conversations',
    conversationRailExpand: 'Expand conversations',
    conversationRailEmptyTitle: 'No conversations yet',
    conversationRailEmptyDescription: 'Start a task to create the first conversation.',
    conversationRailNoMatch: 'No conversations match this search.',
    conversationRailRepositoryUnavailable: 'Repository unavailable',
    workspaceTasks: 'Tasks',
    workspaceBoard: 'Board',
    workspaceReviews: 'Reviews',
    workspaceAutomations: 'Automations',
    workspaceUsage: 'Usage',
    workspaceSettings: 'Settings',
    cloudRunner: 'Cloud runner',
    noTasksTitle: 'No tasks in this Repository',
    noTasksDescription: 'Describe a task above to start the first conversation.',
    boardDescription: 'Connect an existing Board and let Cards start this Repository\'s agent.',
    reviewsDescription: 'Independent review runs for this Repository.',
    reviewsEmptyDescription: 'Create a review without mixing it into implementation tasks.',
    boardNotConnected: 'No Board connected',
    boardNotConnectedDescription: 'Connect an existing Board when you are ready. The Repository workspace itself is already available.',
    boardWorkflowAria: 'Default Agent Board workflow',
    boardBacklog: 'Backlog',
    boardBacklogDescription: 'Cards waiting for work',
    boardAgentQueue: 'Agent queue',
    boardAgentQueueDescription: 'Cards that start jcode',
    boardDoneOptional: 'Done (optional)',
    boardDoneDescription: 'Successful results',
    attachmentsAfterConversation: 'Attachments become available after this Repository has an active conversation.',
    modeCeilingHint: 'Cloud tasks support approval, plan, and auto modes.',
    baseBranchAria: 'Base branch {branch}',
    unavailable: 'unavailable',
    loadingBranches: 'Loading branches…',
    branchUnavailable: 'Branch unavailable',
    startingRepositoryTask: 'Starting the Repository task…',
    branchesUnavailable: 'Repository branches are unavailable.',
    noToolModel: 'No Account-authorized model supports agent tool use.',
    remoteSetup: 'Remote setup',
    deviceOffline: 'This device is offline. Open jcode on the device and try again.',
    startingConversation: 'Starting a new conversation',
    deviceSlow: 'The device is taking longer than expected…',
    creatingOnDevice: 'Creating on device…',
    taskAria: 'Describe a task', taskPlaceholder: 'Describe a task…', repositoryAria: 'Repository',
    accountLoading: 'Loading repositories…', chooseAccountRepository: 'Choose repository',
    modelsLoading: 'Loading models…', modelRequired: 'Choose model', startTask: 'Start task',
    startFailed: 'Could not start the task.',
    accountLoadError: 'Account repositories could not be loaded. Reconnect your provider account and try again.',
    linkAccount: 'Link a Git provider account to choose a repository.',
    reviewGitAccountAccess: 'Review Git account access',
    authorizeModel: 'Ask an administrator to authorize a model for your Account.',
    reviewModelAccess: 'Review model access',
    detailsTitle: 'Repository details',
    detailsDescription: 'Open settings, Agent Board, and task history for repositories you have already used.',
    noDetails: 'Repository details appear here after you start the first task. No connection step is required.',
    connect: 'Connect repository',
    preparing: 'Preparing your Repository workspace…',
    prepareError: 'Repository workspace could not be prepared',
    connectionsTitle: 'Provider accounts',
    connectionsDescription: 'Manage account providers and JType access. Repositories need no separate connection step.',
    chooseRepository: 'Choose repository',
    loading: 'Loading repositories…',
    loadError: 'Repositories could not be loaded',
    emptyEyebrow: 'Start with code',
    emptyTitle: 'Connect your first Repository',
    emptyBody: 'Choose a repository to create its Agent workspace. The personal workspace stays implicit.',
    listTitle: 'Connected repositories',
    visible: 'visible',
    search: 'Search repositories',
    searchPlaceholder: 'Search owner or repository…',
    noMatch: 'No repositories match this search.',
    details: 'Repository details',
    open: 'Open',
    codeReviews: 'Code reviews',
    loadingOne: 'Loading Repository…',
    loadOneError: 'Repository could not be loaded',
    railAria: 'Repositories',
    noneConnected: 'No Repository connected yet.',
    workspaceAria: '{repositoryName} Repository workspace',
    tabsAria: 'Repository workspace sections',
    tabSettings: 'Repository settings',
    connection: 'Provider connection',
    connectionsIntro: 'Connect each provider once for your Repositories. Healthy connections are available to your Repository tasks.',
    connectionsReadOnly: 'Only the Repository owner or a Cluster administrator can change Provider connections.',
    connectionSummary: '{repositories} Repositories · {automations} Automations',
    providerRequired: 'Connect an enabled GitHub, GitLab, or Gitea Provider before choosing a Repository.',
    configureConnections: 'Configure Provider connections',
    disconnect: 'Disconnect Repository',
    disconnectAria: 'Disconnect {name} Repository',
    disconnectConfirm: 'Disconnect “{name}”? Active tasks will be stopped first, then this Repository’s runs, events, artifacts, automations, and workspace resources will be permanently deleted. This cannot be undone.',
    disconnected: 'Repository “{name}” disconnected.',
    disconnectFailed: 'Could not disconnect the Repository.',
    consentIntro: 'Review the account-wide access this connection gives jcode Cloud before continuing to {provider}.',
    consentShared: 'The token becomes a shared credential for your Repositories; it is not personal to the installer.',
    consentTasks: 'Tasks in your Repositories can use every enabled Provider connection, including this one.',
    consentPersistence: 'This connection remains until it is disconnected or revoked by the Provider.',
    consentPublic: 'On public repositories, an @jcode comment can start a task with the enabled Provider credentials.',
    consentAcknowledge: 'I understand and approve this account-wide Repository access.',
  },
  projects: {
    noServicesConnected: 'No Services connected',
    serviceCount_one: '{count} service',
    serviceCount_other: '{count} services',
    eyebrow: 'Your workspace',
    title: 'Projects',
    description: 'A Project groups the people, Services, model access, and automation policy that ship one product.',
    newProject: 'New Project',
    loadingProjects: 'Loading projects…',
    loadError: 'Couldn\'t load projects',
    empty: {
      eyebrow: 'Start with the boundary',
      title: 'No Projects yet.',
      body: 'Create the first Project as an empty container. The next screen lets you authorize repositories as Services without pretending unavailable providers are connected.',
      cta: 'Create first Project',
    },
    listTitle: 'All Projects',
    visible: 'visible',
    searchProjects: 'Search projects',
    searchPlaceholder: 'Search name or Service…',
    updatedJustNow: 'updated just now',
    searchEmptyTitle: 'No matching Projects.',
    searchEmptyBody: 'Try a Project, Service, or repository name.',
    createdAt: 'Created {time}',
    openWorkspace: 'Open workspace',
    guide: {
      eyebrow: 'How Projects work',
      title: 'Keep ownership broad. Keep execution explicit.',
      body: 'A Project is the long-lived boundary; each repository becomes a Service with its own model and automation wiring.',
      step1Title: 'Create the boundary',
      step1Desc: 'Name the product or team.',
      step2Title: 'Add Services',
      step2Desc: 'Authorize repositories explicitly.',
      step3Title: 'Start Tasks',
      step3Desc: 'Only after dependencies are ready.',
    },
    create: {
      nameRequired: 'Name is required.',
      created: 'Project “{name}” created.',
      createFailed: 'Failed to create project.',
      submit: 'Create project',
      nameLabel: 'Name',
      namePlaceholder: 'demo',
      nameHint: 'You\'ll add repositories on the project page next.',
    },
    new: {
      nameRequired: 'Name is required.',
      created: 'Project created.',
      createFailed: 'Could not create the Project.',
      heading: 'Create a Project',
      subheading: 'Start with the ownership boundary. Services come next.',
      draft: 'draft',
      step1Eyebrow: '01 / identity',
      section1Title: 'Project details',
      section1Body: 'Use the product or team boundary people will recognize.',
      nameLabel: 'Name',
      namePlaceholder: 'e.g. jcode Cloud',
      nameHint: 'You can rename the Project later without changing Service URLs.',
      step2Eyebrow: '02 / boundary',
      section2Title: 'What belongs here',
      section2Body: 'Repositories are added as Services after creation.',
      calloutStrong: 'No repository is created or connected yet.',
      calloutBody: 'The resulting workspace opens empty, where the owner explicitly authorizes each Service.',
      submit: 'Create Project',
      asideEyebrow: 'After creation',
      asideTitle: 'The workspace opens empty.',
      asideBody: 'This keeps Project creation honest: a container can exist even when no Git provider or model is available yet.',
      asideItem1: 'Connect repositories as Services.',
      asideItem2: 'Review models granted by the Cluster administrator.',
      asideItem3: 'Start a Task only after required dependencies are configured.',
    },
  },

  usage: {
    title: 'Usage',
    disclaimer: 'Usage is operational telemetry, not a provider invoice.',
    accountTitle: 'Cloud model usage',
    accountDescription: 'Model usage from this account’s devices.',
    proxyOnly: 'Only requests sent through Cloud Model Proxy are included.',
    unavailable: 'Unavailable',
    reasonNotReported: 'The provider did not report usage for this request.',
    reasonNoRequests: 'No usage-bearing requests in this range.',
    reasonParseError: 'Cloud couldn’t parse the provider usage payload.',
    input: 'Input',
    output: 'Output',
    cacheRead: 'Cache read',
    cacheWrite: 'Cache write',
    captured: '{captured} / {requests} captured',
    captureReported: 'Reported',
    captureIncomplete: 'Incomplete',
    reported: 'Reported',
    estimated: 'Estimated',
    uncosted: 'Uncosted',
    details: 'Pricing & capture details',
    requests: 'Requests',
    reportedCapture: 'Reported capture',
    partialCapture: 'Partial capture',
    unavailableCapture: 'Unavailable capture',
    parseErrors: 'Parse errors',
    pricingRevisions: 'Pricing revisions',
    none: 'None',
    pricing: 'Pricing',
    pricingTitle: '{model} pricing',
    pricingImmutable: 'Pricing revisions are immutable. Add a new effective revision instead of editing history.',
    addPricingRevision: 'Add revision',
    currency: 'Currency',
    effectiveAt: 'Effective at',
    inputRate: 'Input / 1M tokens',
    outputRate: 'Output / 1M tokens',
    cacheReadRate: 'Cache read / 1M tokens',
    cacheWriteRate: 'Cache write / 1M tokens',
    pricingHistory: 'Revision history',
    loadingPricing: 'Loading pricing…',
    pricingLoadError: 'Couldn’t load pricing',
    noPricingRevisions: 'No pricing revisions yet. Usage remains Uncosted unless the provider reports cost.',
    pricingValidation: 'Use a valid currency, effective time, and at least one non-negative rate.',
    pricingCreateError: 'Couldn’t create pricing revision',
    loading: 'Loading usage…',
    loadError: 'Couldn’t load usage',
    groupBy: 'Group by',
    group: { service: 'Repository', automation: 'Automation', model: 'Model', device: 'Device', grant: 'Grant' },
    range: 'Range',
    range24h: '24 hours',
    range7: '7 days',
    range30: '30 days',
    range90: '90 days',
    windowNote: 'Showing {range} in {timeZone}. Aggregation uses UTC hourly buckets.',
    captureHealth: 'Capture health',
    costSources: 'Cost sources',
    reportedHelp: 'Returned by the provider; never combined with Cloud estimates.',
    estimatedHelp: 'Calculated from immutable pricing revisions.',
    uncostedHelp: 'Tokens without an applicable category rate.',
    groupedUsage: 'Usage by {group}',
    noGroups: 'No attributed usage in this range.',
    category: {
      input: 'input',
      output: 'output',
      cache_read: 'cache read',
      cache_write: 'cache write',
    },
  },
  runDetail: {
    loadingRun: 'Loading run…',
    loadRunError: 'Couldn\'t load run',
    loadingWorkspace: 'Loading project workspace…',
    projectName: 'Project {id}',
    nav: {
      projects: 'Projects',
      repositories: 'Repositories',
    },
    railFooter: 'Project workspace',
    repositoryWorkspace: 'Repository workspace',
    breadcrumbLabel: 'Breadcrumb',
    breadcrumb: {
      tasks: 'Tasks',
      detail: 'Detail',
    },
    recentTasks: 'Recent tasks',
    serviceUnavailable: 'Repository unavailable',
    repositoryUnavailable: 'Repository unavailable',
    noChangesBadge: 'No changes',
    action: {
      stop: 'Stop',
      retry: 'Retry',
      retryOtherModel: 'Switch model',
      conversation: 'Conversation',
    },
    retryModel: {
      title: 'Retry with another model',
      description: 'Start a new attempt with a different model. The workflow, repository revision, permissions, and delivery contract stay unchanged.',
      current: 'Current model',
      choose: 'Choose another Account model',
      unknown: 'Unknown model',
      confirm: 'Switch model and retry',
	  originalUnavailable: 'The original model is no longer available. Choose another Account model.',
    },
    you: 'You',
    reviewInProgress: 'Review in progress…',
    reviewFailed: 'This review failed, so no output was produced.',
    noReviewOutput: 'No review output was produced.',
    noEvents: 'No conversation events were recorded.',
    waitingForAgent: 'Waiting for the agent…',
    streamDisconnected: 'Live updates disconnected. Showing periodic refreshes.',
    reconnect: 'Reconnect',
    refreshError: 'Couldn\'t refresh the latest run details — showing the last known state.',
    modelLabel: 'Model',
    toast: {
      permissionDecisionFailed: 'Could not send the permission decision.',
      messageFailed: 'Could not send the message.',
      sessionResumed: 'Session resumed.',
      resumeFailed: 'Could not resume the session.',
      canceled: 'Run canceled.',
      cancelFailed: 'Cancel failed.',
      retryDispatched: 'Retry dispatched.',
      retryFailed: 'Retry failed.',
      sessionFinishing: 'Session finishing — the agent is wrapping up.',
      finishFailed: 'Could not finish the session.',
    },
    failure: {
      cloneFailed: 'Repository clone failed',
      setupFailed: 'Project setup failed',
      agentError: 'Agent error',
      modelRateLimited: 'Model rate limited',
      timeout: 'Timed out',
      pushFailed: 'Branch push failed',
      runFailed: 'Run failed',
      noMessage: 'The run failed without a message.',
    },
    kind: {
      codeReview: 'Code review',
      session: 'Session',
      automatedTask: 'Automated task',
      manualTask: 'Manual task',
    },
    originLabel: {
      webhook: 'Provider webhook',
      schedule: 'Schedule',
      kanban: 'Kanban',
      prEvent: 'PR event',
      manual: 'Manual',
    },
    session: {
      sessionQueued: 'Session queued — waiting for a free concurrency slot.',
      sessionStarting: 'Session starting — the workspace is being scheduled.',
      sessionActionsHint: 'Finish lets the agent wrap up after the current turn; Cancel stops immediately.',
      finishSession: 'Finish session',
      resumeHint: 'Continue this session — the agent keeps the same context.',
    },
    composer: {
      continuePlaceholder: 'Continue this task…',
      followUpPlaceholder: 'Queue a follow-up — it will run after the current turn…',
      serviceDefault: 'Repository default',
      useServiceModel: 'Use the Repository configured model',
      modelFixed: 'Model is fixed for this active session',
      messageInput: 'Message input',
      attachmentsUnavailableTitle: 'Attachments are not available in Cloud sessions yet.',
      attachmentsUnavailable: 'Attachments unavailable',
      modelAccessLocked: 'Model and access apply when you resume.',
      modeCeilingHint: 'Cloud sessions support approval, plan, and auto modes.',
      queue: 'Queue',
      send: 'Send',
      sendMessage: 'Send message',
    },
    model: {
      disabledTitle: 'The active agent session keeps its existing model.',
      chooseTitle: 'Choose the Account model for the resumed session.',
      filterModels: 'Filter models',
      filterModelsPlaceholder: 'Filter models…',
      modelsHeading: 'Models',
      noMatchingModels: 'No matching models',
    },
    permission: {
      askForApproval: 'Ask for approval',
      askForApprovalSub: 'Agent asks before running tools',
      plan: 'Plan',
      planSub: 'Not available in Cloud sessions yet',
      fullAccess: 'Full access',
      fullAccessSub: 'Agent can act without asking',
      permissionMode: 'Permission mode',
      disabledTitle: 'The active agent session keeps its existing permission mode.',
      chooseTitle: 'Choose how the resumed agent asks for permission.',
    },
    inspector: {
      runDetailsLabel: 'Run details',
      identityAndSource: 'Identity & source',
      requestedBy: 'Requested by',
      accountableTo: 'Accountable to',
      triggeredFrom: 'Triggered from',
      executedFor: 'Executed for',
      project: 'Project',
      repository: 'Repository',
      dispatchSnapshot: 'Dispatch-time snapshot',
      writtenBackAs: 'Written back as',
      externalActor: 'External actor',
      ruleOwner: 'Rule owner',
      botOrApp: 'Bot / App',
      notAttributed: 'Not attributed',
      notApplicable: 'Not applicable',
      technicalIdentity: 'Technical identity',
      runtimePrincipal: 'Runtime',
      attribution: 'Attribution',
      source: 'Source',
      precisionExact: 'Exact',
      precisionLinkedExternal: 'Linked external identity',
      precisionRuleOwner: 'Attributed to rule owner',
      precisionUnattributed: 'Unattributed',
      runOverview: 'Run overview',
      service: 'Service',
      unavailable: 'Unavailable',
      trigger: 'Trigger',
      notReported: 'Not reported',
      permission: 'Permission',
      askBeforeActions: 'Ask before actions',
      workspace: 'Workspace',
      changes: 'Changes',
      noCodeChanges: 'No code changes',
      reviewPatch: 'Review the complete patch',
      loadingChangeSummary: 'Loading change summary…',
      diffUnavailable: 'Diff unavailable',
      diffAfterAgent: 'Available after the agent produces a diff',
      viewCompleteDiff: 'View complete diff',
      openPrDetails: 'Open pull request details',
      draftPr: 'Draft PR',
      readyPr: 'Ready PR',
      pullRequest: 'Pull request',
      closedPr: 'Closed PR',
      mergedPr: 'Merged PR',
      prDeliveryConflict: 'Pull request delivery is parked because multiple open PRs use this branch.',
      prProviderUnsupported: 'The Git provider could not reliably change this pull request to Ready.',
      executionStatus: 'Execution status',
      deliveryStatus: 'Delivery status',
      deliveryKind: 'Destination',
      deliveryIssue: 'Delivery issue',
      deliveryUnknown: 'Not reported',
      delivery: { not_required: 'Not required', pending: 'Pending', delivered: 'Delivered', failed: 'Failed' },
      deliveryKindLabel: { artifact: 'Artifact', pull_request: 'Pull request', branch_update: 'Branch update', review_comment: 'Review comment' },
      execution: 'Execution',
      started: 'Started',
      notStarted: 'Not started',
      duration: 'Duration',
      runId: 'Run ID',
      retryOf: 'Retry of',
      resumedFrom: 'Resumed from',
      resumedFromLink: 'resumed from {id}',
    },
    contract: {
      title: 'Execution contract',
      legacyUnavailable: 'This historical Run predates immutable execution contracts.',
      workflow: 'Workflow',
      profile: 'Agent profile',
      trigger: 'Trigger',
      model: 'Model',
      timeout: 'Timeout',
      delivery: 'Delivery',
      verification: 'Verification',
      technical: 'Technical contract',
      hash: 'Contract hash',
      definition: 'Definition',
      access: 'Workspace',
      requirements: 'Requirements',
    },
    coverage: {
      eyebrow: 'Review input',
      title: 'Review coverage',
      unavailable: 'Unavailable',
      legacyUnavailable: 'Coverage was not recorded for this historical review Run.',
      complete: 'Complete',
      partial: 'Partial',
      files: 'files indexed',
      hunks: 'hunks indexed',
      lines: 'changed lines',
      baseHead: 'Base → head',
      mergeBase: 'Merge base',
      skipped: '{count} skipped files',
      indexed: '{count} covered files',
      ledger: 'Coverage ledger',
      fileStats: '{hunks} hunks · {lines} lines',
      noneSkipped: 'No files were skipped.',
      noneIndexed: 'No files were indexed.',
      unsupported: 'unsupported',
    },
    review: {
      titleFallback: 'Pull request review #{number}',
      pullRequest: 'Pull request',
      base: 'Base',
      head: 'Head',
      revisions: 'Frozen revisions',
      delivery: {
        running: 'Reviewing',
        posting: 'Posting review',
        posted: 'Posted',
        incomplete: 'Writeback incomplete',
        unavailable: 'Result unavailable',
        error: 'Writeback retrying',
      },
      deliveryError: {
        title: 'Provider writeback needs attention',
      },
      stage: {
        planTitle: 'Preparing deterministic review plan',
        planBody: 'Freezing the exact base/head revisions and indexing changed lines.',
        analysisTitle: 'Analyzing indexed changes',
        analysisBody: 'The accepted coverage plan is now being checked for high-confidence defects.',
        activity: 'Runner activity',
      },
      legacy: {
        title: 'Structured review result unavailable',
        body: 'This terminal Run predates the structured review contract or did not produce a valid result. Legacy provider Markdown is intentionally not rendered as Cloud state.',
      },
      result: {
        eyebrow: 'Validated output',
        title: 'Review findings',
        count: '{count} findings',
        noFindings: 'No high-confidence defects were found in the indexed changes.',
        incompleteTitle: 'Review incomplete',
        incompleteBody: 'No clean conclusion was reached. Confirmed findings remain visible, but zero findings does not mean this pull request is clear.',
        confidence: '{confidence}% confidence',
        suggestion: 'Suggested change',
        checks: '{count} validation checks',
      },
      grant: {
        title: 'Frozen SCM grant',
        provider: 'Provider',
        repository: 'Repository',
        installation: 'Installation',
        config: 'Provider config',
        credential: 'Credential version',
        principal: 'Acting principal',
        unavailable: 'The repository grant has not been frozen yet or is unavailable for this historical Run.',
      },
    },
    origin: {
      fromPrComment: 'from PR comment',
      scheduled: 'scheduled',
      kanbanAutomation: 'Kanban Automation',
      prEventAutomation: 'PR event Automation',
    },
    diff: {
      runFailedNoDiff: 'This run failed, so no diff was produced.',
      diffAfterArtifact: 'The diff will be available after the agent produces an artifact.',
      noCodeChanges: 'This run made no code changes.',
      loadingDiff: 'Loading diff…',
      loadDiffError: 'Couldn\'t load diff',
    },
    failedSubmission: {
      notSent: 'Message not sent.',
      draftPreserved: 'Your draft is preserved.',
      retryUnsent: 'Retry unsent message',
    },
  },
};
